/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 74);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(96);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=74)}([function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(83),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()},function(t,e){var n=t.exports={version:"2.5.4"};"number"==typeof __e&&(__e=n)},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var r=n(35)("wks"),o=n(22),i=n(3).Symbol,a="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))}).store=r},function(t,e,n){var r=n(3),o=n(2),i=n(12),a=n(10),u=n(11),s=function(t,e,n){var c,l,f,d=t&s.F,h=t&s.G,p=t&s.S,v=t&s.P,y=t&s.B,g=t&s.W,m=h?o:o[e]||(o[e]={}),w=m.prototype,_=h?r:p?r[e]:(r[e]||{}).prototype;h&&(n=e);for(c in n)(l=!d&&_&&void 0!==_[c])&&u(m,c)||(f=l?_[c]:n[c],m[c]=h&&"function"!=typeof _[c]?n[c]:y&&l?i(f,r):g&&_[c]==f?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(f):v&&"function"==typeof f?i(Function.call,f):f,v&&((m.virtual||(m.virtual={}))[c]=f,t&s.R&&w&&!w[c]&&a(w,c,f)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},function(t,e,n){var r=n(7),o=n(46),i=n(30),a=Object.defineProperty;e.f=n(9)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(8);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){t.exports=!n(13)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(6),o=n(16);t.exports=n(9)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(20);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(48),o=n(31);t.exports=function(t){return r(o(t))}},function(t,e){t.exports=__webpack_require__(21)},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports={}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(39),i=r(o),a=n(0),u=r(a),s=n(1),c=r(s),l=n(25),f=r(l),d=n(15),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(d),p=n(127),v=r(p);Object.defineProperty(e,"__esModule",{value:!0});var y=function(){function t(){(0,u.default)(this,t)}return(0,c.default)(t,null,[{key:"stripTrailingSlash",value:function(t){return"/"===t.substr(-1)?t.substr(0,t.length-1):t}},{key:"getPort",value:function(t){var e=void 0===t?window.location.port:t,n=window.location.protocol;return""===e?"http:"===n?80:"https:"===n?443:void 0:parseInt(e)}},{key:"cleanLink",value:function(t){return t.replace(/#.*/,"")}},{key:"getCurrentUrl",value:function(){return window.location.protocol+"//"+window.location.host+window.location.pathname+window.location.search}},{key:"requestTimeout",value:function(){return 1e4}},{key:"request",value:function(e){var n=!!(1<arguments.length&&void 0!==arguments[1])&&arguments[1],r=t.deferred(),o=window.setTimeout(function(){window.clearTimeout(o),r.reject("timeout!")},t.requestTimeout());if(window.Worker&&n){var i=(0,v.default)(128);i.addEventListener("message",function(t){var e=JSON.parse(t.data);return e.err?(window.clearTimeout(o),i.terminate(),void r.reject(e.err)):(i.terminate(),r.resolve(e.res))}),i.postMessage({url:e})}else{var a=new window.Headers;a.append("X-Starting-Blocks","yes"),a.append("X-Allow-Partial","yes"),a.append("X-Requested-With","XMLHttpRequest"),window.fetch(e,{method:"GET",headers:a,cache:"default",credentials:"same-origin"}).then(function(t){if(window.clearTimeout(o),200<=t.status&&300>t.status)return r.resolve(t.text());var e=new Error(t.statusText||t.status);return r.reject(e)}).catch(function(t){window.clearTimeout(o),r.reject(t)})}return r.promise}},{key:"logCredits",value:function(t,e,n,r,o){var i="#fff";if(void 0!==o&&(i=o),console.log("%c   ","font-size:3px;"),console.log("%c"+t,"background:"+e+"; color: "+i+"; font-size:14px; padding:5px 10px;"),console.log("%c   ","font-size:3px;"),null!==n){var a=n.length;if(a)for(var u=0;u<a;u++)console.log(n[u].name+" - "+n[u].website)}if(null!==r){var s=r.length;if(s){console.log("-"),console.log("Thanks to");for(var c=0;c<s;c++)console.log(r[c].name+" ("+r[c].website+")")}}console.log("-"),console.log(" ")}},{key:"getStyleVal",value:function(t,e){var n=t.css(e);return Math.round(+n.substr(0,n.length-2))}},{key:"addClass",value:function(t,e){t.classList?t.classList.add(e):t.className+=" "+e}},{key:"removeClass",value:function(t,e){if(t.classList)t.classList.remove(e);else{t.className=t.className.replace(new RegExp("(^|\\b)"+e.split(" ").join("|")+"(\\b|$)","gi"),"");var n=t.className.length-1;" "===t.className[n]&&(t.className=t.className.substring(0,n))}}},{key:"getRandomNumber",value:function(t,e,n){var r=Math.random()*(e-t)+t;return void 0===n?r:+r.toFixed(n)}},{key:"getRandomInt",value:function(t,e){return Math.floor(Math.random()*(e-t+1))+t}},{key:"replacePlaceholder",value:function(){var t=(0,f.default)("[placeholder]");void 0===window.Modernizr||window.Modernizr.input.placeholder||(t.focus(function(){var t=(0,f.default)(this);t.val()===t.attr("placeholder")&&(t.val(""),t.removeClass("placeholder"))}).blur(function(){var t=(0,f.default)(this);(""===t.val()||t.val()===t.attr("placeholder"))&&(t.addClass("placeholder"),t.val(t.attr("placeholder")))}).blur(),t.parents("form").submit(function(){(0,f.default)(this).find("[placeholder]").each(function(){var t=(0,f.default)(this);t.val()===t.attr("placeholder")&&t.val("")})}))}},{key:"trackGoogleAnalytics",value:function(){void 0!==window.ga&&(h.debug("🚩 Push Analytics for: "+window.location.pathname),window.ga("send","pageview",{page:window.location.pathname,title:document.title}))}},{key:"getViewportSize",value:function(){var t=window,e="inner";return"innerWidth"in window||(e="client",t=document.documentElement||document.body),{width:t[e+"Width"],height:t[e+"Height"]}}},{key:"prefixProperty",value:function(t){for(var e,n=["","ms","Webkit","Moz","O"],r=n.length,o=document.createElement("div"),i=0;i<r;i++){e=n[i],t=""===e?t:t.charAt(0).toUpperCase()+t.substring(1).toLowerCase();var a=e+t;if(void 0!==o.style[a])return a}}},{key:"getNormRatio",value:function(t,e,n){return t<e?0:t>n?1:t===n?1:(t-e)/(n-e)}},{key:"deferred",value:function(){return new function(){var t=this;this.resolve=null,this.reject=null,this.promise=new i.default(function(e,n){t.resolve=e,t.reject=n})}}}]),t}();e.default=y},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var r=n(47),o=n(36);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(31);t.exports=function(t){return Object(r(t))}},function(t,e){t.exports=__webpack_require__(13)},function(t,e){t.exports=!0},function(t,e,n){var r=n(6).f,o=n(11),i=n(4)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.BEFORE_PAGE_LOAD="SB_BEFORE_PAGE_LOAD",e.AFTER_PAGE_LOAD="SB_AFTER_PAGE_LOAD",e.AFTER_DOM_APPENDED="SB_AFTER_DOM_APPENDED",e.CONTAINER_READY="SB_CONTAINER_READY",e.AFTER_PAGE_BOOT="SB_AFTER_PAGE_BOOT",e.BEFORE_PAGE_SHOW="SB_BEFORE_PAGE_SHOW",e.AFTER_PAGE_SHOW="SB_AFTER_PAGE_SHOW",e.BEFORE_PAGE_HIDE="SB_BEFORE_PAGE_HIDE",e.AFTER_PAGE_HIDE="SB_AFTER_PAGE_HIDE",e.TRANSITION_START="SB_TRANSITION_START",e.TRANSITION_COMPLETE="SB_TRANSITION_COMPLETE"},function(t,e,n){var r=n(8),o=n(3).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(8);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(33),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(35)("keys"),o=n(22);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(3),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(15),c=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(){(0,i.default)(this,t)}return(0,u.default)(t,[{key:"commit",value:function(t,e){var n=new window.CustomEvent(t,{detail:e});c.debug("🚩 Dispatched "+t),window.dispatchEvent(n)}}]),t}();e.default=new l},function(t,e,n){t.exports={default:n(87),__esModule:!0}},function(t,e,n){"use strict";var r=n(88)(!0);n(52)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(7),o=n(90),i=n(36),a=n(34)("IE_PROTO"),u=function(){},s=function(){var t,e=n(29)("iframe"),r=i.length;for(e.style.display="none",n(54).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),s=t.F;r--;)delete s.prototype[i[r]];return s()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=r(t),n=new u,u.prototype=null,n[a]=t):n=s(),void 0===e?n:o(n,e)}},function(t,e,n){"use strict";function r(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=o(e),this.reject=o(n)}var o=n(20);t.exports.f=function(t){return new r(t)}},function(t,e,n){e.f=n(4)},function(t,e,n){var r=n(3),o=n(2),i=n(26),a=n(43),u=n(6).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||u(e,t,{value:a.f(t)})}},function(t,e,n){"use strict";function r(t,e,n){var r;return function(){var o=this,i=arguments,a=n&&!r;clearTimeout(r),r=setTimeout(function(){r=null,n||t.apply(o,i)},e),a&&t.apply(o,i)}}Object.defineProperty(e,"__esModule",{value:!0}),e.default=r},function(t,e,n){t.exports=!n(9)&&!n(13)(function(){return 7!=Object.defineProperty(n(29)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(11),o=n(14),i=n(81)(!1),a=n(34)("IE_PROTO");t.exports=function(t,e){var n,u=o(t),s=0,c=[];for(n in u)n!=a&&r(u,n)&&c.push(n);for(;e.length>s;)r(u,n=e[s++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){var r=n(17);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a);Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(){(0,i.default)(this,t),this.data={}}return(0,u.default)(t,[{key:"exists",value:function(t){return t in this.data}},{key:"get",value:function(t){return this.data[t]}},{key:"set",value:function(t,e){return this.data[t]=e,this}},{key:"reset",value:function(){this.data={}}}]),t}();e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(39),i=r(o),a=n(103),u=r(a),s=n(0),c=r(s),l=n(1),f=r(l),d=n(107),h=r(d),p=n(119),v=r(p),y=n(69),g=r(y);Object.defineProperty(e,"__esModule",{value:!0});var m=function(t){function e(){return(0,c.default)(this,e),(0,h.default)(this,(e.__proto__||(0,u.default)(e)).apply(this,arguments))}return(0,v.default)(e,t),(0,f.default)(e,[{key:"start",value:function(){i.default.all([this.newPageLoading]).then(this.finish.bind(this))}},{key:"finish",value:function(){document.body.scrollTop=0,this.done()}}]),e}(g.default);e.default=m},function(t,e){},function(t,e,n){"use strict";var r=n(26),o=n(5),i=n(53),a=n(10),u=n(18),s=n(89),c=n(27),l=n(55),f=n(4)("iterator"),d=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,p,v,y,g){s(n,e,p);var m,w,_,b=function(t){if(!d&&t in O)return O[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},k=e+" Iterator",E="values"==v,x=!1,O=t.prototype,P=O[f]||O["@@iterator"]||v&&O[v],S=P||b(v),L=v?E?b("entries"):S:void 0,T="Array"==e?O.entries||P:P;if(T&&(_=l(T.call(new t)))!==Object.prototype&&_.next&&(c(_,k,!0),r||"function"==typeof _[f]||a(_,f,h)),E&&P&&"values"!==P.name&&(x=!0,S=function(){return P.call(this)}),r&&!g||!d&&!x&&O[f]||a(O,f,S),u[e]=S,u[k]=h,v)if(m={values:E?S:b("values"),keys:y?S:b("keys"),entries:L},g)for(w in m)w in O||i(O,w,m[w]);else o(o.P+o.F*(d||x),e,m);return m}},function(t,e,n){t.exports=n(10)},function(t,e,n){var r=n(3).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(11),o=n(24),i=n(34)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){n(91);for(var r=n(3),o=n(10),i=n(18),a=n(4)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<u.length;s++){var c=u[s],l=r[c],f=l&&l.prototype;f&&!f[a]&&o(f,a,c),i[c]=i.Array}},function(t,e,n){var r=n(17),o=n(4)("toStringTag"),i="Arguments"==r(function(){return arguments}()),a=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=a(e=Object(t),o))?n:i?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){var r=n(7);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(18),o=n(4)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(57),o=n(4)("iterator"),i=n(18);t.exports=n(2).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e,n){var r=n(7),o=n(20),i=n(4)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||void 0==(n=r(a)[i])?e:o(n)}},function(t,e,n){var r,o,i,a=n(12),u=n(97),s=n(54),c=n(29),l=n(3),f=l.process,d=l.setImmediate,h=l.clearImmediate,p=l.MessageChannel,v=l.Dispatch,y=0,g={},m=function(){var t=+this;if(g.hasOwnProperty(t)){var e=g[t];delete g[t],e()}},w=function(t){m.call(t.data)};d&&h||(d=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return g[++y]=function(){u("function"==typeof t?t:Function(t),e)},r(y),y},h=function(t){delete g[t]},"process"==n(17)(f)?r=function(t){f.nextTick(a(m,t,1))}:v&&v.now?r=function(t){v.now(a(m,t,1))}:p?(o=new p,i=o.port2,o.port1.onmessage=w,r=a(i.postMessage,i,1)):l.addEventListener&&"function"==typeof postMessage&&!l.importScripts?(r=function(t){l.postMessage(t+"","*")},l.addEventListener("message",w,!1)):r="onreadystatechange"in c("script")?function(t){s.appendChild(c("script")).onreadystatechange=function(){s.removeChild(this),m.call(t)}}:function(t){setTimeout(a(m,t,1),0)}),t.exports={set:d,clear:h}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(7),o=n(8),i=n(42);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var r=n(4)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},t(i)}catch(t){}return n}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=n(108),i=r(o),a=n(110),u=r(a),s="function"==typeof u.default&&"symbol"==typeof i.default?function(t){return typeof t}:function(t){return t&&"function"==typeof u.default&&t.constructor===u.default&&t!==u.default.prototype?"symbol":typeof t};e.default="function"==typeof u.default&&"symbol"===s(i.default)?function(t){return void 0===t?"undefined":s(t)}:function(t){return t&&"function"==typeof u.default&&t.constructor===u.default&&t!==u.default.prototype?"symbol":void 0===t?"undefined":s(t)}},function(t,e,n){var r=n(47),o=n(36).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){var r=n(23),o=n(16),i=n(14),a=n(30),u=n(11),s=n(46),c=Object.getOwnPropertyDescriptor;e.f=n(9)?c:function(t,e){if(t=i(t),e=a(e,!0),s)try{return c(t,e)}catch(t){}if(u(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(19),c=r(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(){(0,i.default)(this,t),this.oldPage=void 0,this.newPage=void 0,this.newPageLoading=void 0}return(0,u.default)(t,[{key:"init",value:function(t,e){var n=this;return this.oldPage=t,this._newPagePromise=e,this.deferred=c.default.deferred(),this.newPageReady=c.default.deferred(),this.newPageLoading=this.newPageReady.promise,this.start(),this._newPagePromise.then(function(t){n.newPage=t,n.newPageReady.resolve()}),this.deferred.promise}},{key:"done",value:function(){this.oldPage.destroy(),this.newPage.$cont[0].style.visibility="visible",this.newPage.updateLazyload(),this.deferred.resolve()}},{key:"start",value:function(){}}]),t}();e.default=l},function(t,e,n){t.exports={default:n(129),__esModule:!0}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(135),i=r(o),a=n(138),u=r(a),s=n(0),c=r(s),l=n(1),f=r(l),d=n(15),h=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(d),p=n(25),v=r(p),y=n(139),g=r(y),m=n(45),w=r(m),_=n(38),b=r(_),k=n(28),E=n(72),x=r(E);Object.defineProperty(e,"__esModule",{value:!0});var O=function(){function t(e,n,r,o){if((0,c.default)(this,t),o=o||"page",!n)throw new Error("AbstractPage need a container (HTMLElement) to be defined.");if(!e)throw new Error("AbstractPage need a Router instance to be defined.");if(this.router=e,this.$cont=(0,v.default)(n),!this.$cont)throw new Error("AbstractPage: container not found!");if(this.id=this.$cont.attr("id"),!this.$cont)throw new Error("AbstractPage: container have no id!");this.context=r,this.type=o,this.isHome=!1,"1"===this.$cont.attr("data-is-home")&&(this.isHome=!0),this.lazyload=null,this.blocks=[],this.name=this.$cont.length?this.$cont.attr("data-node-name"):"",this.metaTitle=this.$cont.length?this.$cont.attr("data-meta-title"):"",this.onResize=this.onResize.bind(this),this.onResizeDebounce=(0,w.default)(this.onResize,50,!1),this.bindedUpdateBlocks=(0,w.default)(this.updateBlocks.bind(this),50,!1),this.onLoad=this.onLoad.bind(this),this.onLazyImageSet=this.onLazyImageSet.bind(this),this.onLazyImageLoad=this.onLazyImageLoad.bind(this),this.onLazyImageProcessed=this.onLazyImageProcessed.bind(this),h.debug("✳️ #"+this.id+" %c["+o+"] ["+this.context+"]","color:grey")}return(0,f.default)(t,[{key:"init",value:function(){var t=(0,u.default)(i.default.mark(function t(){return i.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(this.$blocks=this.$cont.find(this.router.options.pageBlockClass),this.blockLength=this.$blocks.length,!this.blockLength){t.next=5;break}return t.next=5,this.initBlocks();case 5:this.router.options.ajaxEnabled&&"ajax"===this.context&&this.initAjax(),this.router.options.lazyloadEnabled&&this.initLazyload(),this.initEvents();case 8:case"end":return t.stop()}},t,this)}));return function(){return t.apply(this,arguments)}}()},{key:"destroy",value:function(){if(h.debug("🗑 #"+this.id),this.$cont.remove(),this.destroyEvents(),null!==this.router.page&&this.router.page.name!==this.name&&this.router.$body.removeClass(this.name),null!==this.router.page&&this.router.page.type!==this.type&&this.router.$body.removeClass(this.type),null!==this.blocks)for(var t in this.blocks)this.blocks[t].destroy();null!==this.lazyload&&(this.lazyload.destroy(),this.lazyload=null)}},{key:"initEvents",value:function(){this.$cont.find("img").length?this.$cont.waitForImages({finished:this.onLoad,waitForAll:!0}):this.onLoad(),window.addEventListener("resize",this.onResizeDebounce),this.domObserver=new window.MutationObserver(this.bindedUpdateBlocks),this.domObserver.observe(this.$cont.get(0),{childList:!0,attributes:!1,characterData:!1,subtree:!0})}},{key:"destroyEvents",value:function(){window.removeEventListener("resize",this.onResizeDebounce),this.domObserver.disconnect()}},{key:"initLazyload",value:function(){this.beforeLazyload(),this.lazyload=new g.default({threshold:this.router.options.lazyloadThreshold,throttle:this.router.options.lazyloadThrottle,elements_selector:"."+this.router.options.lazyloadClass,data_src:this.router.options.lazyloadSrcAttr.replace("data-",""),data_srcset:this.router.options.lazyloadSrcSetAttr.replace("data-",""),callback_set:this.onLazyImageSet,callback_load:this.onLazyImageLoad,callback_processed:this.onLazyImageProcessed})}},{key:"onLoad",value:function(){this.loadDate=new Date,this.loadDuration=this.loadDate-this.router.loadBeginDate,b.default.commit(k.BEFORE_PAGE_SHOW,this)}},{key:"updateLazyload",value:function(){this.lazyload&&this.lazyload.update()}},{key:"show",value:function(t){h.debug("▶️ #"+this.id),this.$cont[0].style.opacity="1",void 0!==t&&t(),this.$cont.removeClass(this.router.options.pageClass+"-transitioning"),b.default.commit(k.AFTER_PAGE_SHOW,this)}},{key:"hide",value:function(t){b.default.commit(k.BEFORE_PAGE_HIDE,this),h.debug("◀️ #"+this.id),this.$cont[0].style.opacity="0",void 0!==t&&t(),b.default.commit(k.AFTER_PAGE_HIDE,this)}},{key:"initAjax",value:function(){this.$cont.addClass(this.router.options.pageClass+"-transitioning")}},{key:"initBlocks",value:function(){var t=(0,u.default)(i.default.mark(function t(){var e,n,r;return i.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:e=0;case 1:if(!(e<this.blockLength)){t.next=9;break}return t.next=4,this.initSingleBlock(this.$blocks.eq(e));case 4:n=t.sent,this.blocks.push(n);case 6:e++,t.next=1;break;case 9:for(r=this.blocks.length-1;0<=r;r--)"function"==typeof this.blocks[r].onPageReady&&this.blocks[r].onPageReady();case 10:case"end":return t.stop()}},t,this)}));return function(){return t.apply(this,arguments)}}()},{key:"updateBlocks",value:function(){var t=(0,u.default)(i.default.mark(function t(){var e,n,r;return i.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:h.debug("\t📯 Page DOM changed…"),this.updateLazyload(),this.$blocks=this.$cont.find(this.router.options.pageBlockClass),this.blockLength=this.$blocks.length,e=0;case 5:if(!(e<this.blockLength)){t.next=22;break}if(n=this.$blocks[e],this.getBlockById(n.id)){t.next=19;break}return t.prev=8,t.next=11,this.initSingleBlock(this.$blocks.eq(e));case 11:r=t.sent,this.blocks.push(r),r.onPageReady(),t.next=19;break;case 16:t.prev=16,t.t0=t.catch(8),h.info(t.t0.message);case 19:e++,t.next=5;break;case 22:case"end":return t.stop()}},t,this,[[8,16]])}));return function(){return t.apply(this,arguments)}}()},{key:"initSingleBlock",value:function(){var t=(0,u.default)(i.default.mark(function t(e){var n,r;return i.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=e[0].getAttribute(this.router.options.objectTypeAttr),t.next=3,this.router.classFactory.getBlockInstance(this,e,n);case 3:if(r=t.sent){t.next=6;break}return t.abrupt("return",new x.default(this,e,n));case 6:return t.abrupt("return",r);case 7:case"end":return t.stop()}},t,this)}));return function(){return t.apply(this,arguments)}}()},{key:"getBlockById",value:function(t){var e=this.getBlockIndexById(t);return this.blocks[e]?this.blocks[e]:null}},{key:"getBlockIndexById",value:function(t){for(var e in this.blocks)if(this.blocks.hasOwnProperty(e)&&this.blocks[e]&&this.blocks[e].id&&this.blocks[e].id===t)return e;return null}},{key:"getFirstBlockByType",value:function(t){var e=this.getFirstBlockIndexByType(t);return this.blocks[e]?this.blocks[e]:null}},{key:"getFirstBlockIndexByType",value:function(t){for(var e in this.blocks)if(this.blocks.hasOwnProperty(e)&&this.blocks[e]&&this.blocks[e].type&&this.blocks[e].type===t)return e;return null}},{key:"onResize",value:function(){}},{key:"beforeLazyload",value:function(){}},{key:"onLazyImageSet",value:function(t){h.debug("\t🖼 «"+t.id+"» set")}},{key:"onLazyImageLoad",value:function(t){h.debug("\t🖼 «"+t.id+"» load")}},{key:"onLazyImageProcessed",value:function(){h.debug("\t🖼 Lazy load processed")}}]),t}();e.default=O},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(15),c=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(s),l=n(45),f=r(l);Object.defineProperty(e,"__esModule",{value:!0});var d=function(){function t(e,n,r){(0,i.default)(this,t),r=r||"block",this.page=e,this.$cont=n,this.id=n.attr("id"),this.type=r,this.name=this.$cont.length?this.$cont.attr("data-node-name"):"",this.onResize=this.onResize.bind(this),this.onLoad=this.onLoad.bind(this),this.onResizeDebounce=(0,f.default)(this.onResize,50,!1),c.debug("\t✳️ #"+this.id+" %c["+r+"]","color:grey"),this.init(),this.initEvents()}return(0,u.default)(t,[{key:"init",value:function(){}},{key:"initEvents",value:function(){this.$cont.find("img").length?this.$cont.waitForImages({finished:this.onLoad,waitForAll:!0}):this.onLoad(),window.addEventListener("resize",this.onResizeDebounce)}},{key:"destroy",value:function(){c.debug("\t🗑 #"+this.id),this.destroyEvents()}},{key:"destroyEvents",value:function(){window.removeEventListener("resize",this.onResizeDebounce)}},{key:"onResize",value:function(){}},{key:"onLoad",value:function(){}},{key:"onPageReady",value:function(){}}]),t}();e.default=d},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(15),c=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(){(0,i.default)(this,t),c.debug("🌀 Construct loader")}return(0,u.default)(t,[{key:"show",value:function(){c.debug("🌀 Show loader")}},{key:"hide",value:function(){c.debug("🌀 Hide loader")}}]),t}();e.default=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.DefaultTransition=e.EventTypes=e.BootstrapMedia=e.debounce=e.gaTrackErrors=e.polyfills=e.Scroll=e.Utils=e.AbstractTransition=e.AbstractBlock=e.AbstractPage=e.GraphicLoader=e.CacheProvider=e.Router=void 0;var o=n(75),i=r(o),a=n(49),u=r(a),s=n(73),c=r(s),l=n(71),f=r(l),d=n(72),h=r(d),p=n(69),v=r(p),y=n(50),g=r(y),m=n(19),w=r(m),_=n(140),b=r(_),k=n(141),E=r(k),x=n(146),O=r(x),P=n(45),S=r(P),L=n(147),T=r(L),j=n(28),A=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(j);e.Router=i.default,e.CacheProvider=u.default,e.GraphicLoader=c.default,e.AbstractPage=f.default,e.AbstractBlock=h.default,e.AbstractTransition=v.default,e.Utils=w.default,e.Scroll=b.default,e.polyfills=E.default,e.gaTrackErrors=O.default,e.debounce=S.default,e.BootstrapMedia=T.default,e.EventTypes=A,e.DefaultTransition=g.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(76),i=r(o),a=n(0),u=r(a),s=n(1),c=r(s),l=n(25),f=r(l),d=n(49),h=r(d),p=n(38),v=r(p),y=n(86),g=r(y),m=n(28),w=n(130),_=r(w),b=n(131),k=r(b),E=n(132),x=r(E),O=n(133),P=r(O),S=n(134),L=r(S),T=n(73),j=r(T);Object.defineProperty(e,"__esModule",{value:!0});var A={ajaxEnabled:!0,pageClass:"page-content",ajaxWrapperId:"sb-wrapper",objectTypeAttr:"data-node-type",noAjaxLinkClass:"no-ajax-link",noPrefetchLinkClass:"no-prefetch",pageBlockClass:".page-block",lazyloadEnabled:!1,prefetchEnabled:!0,workerEnabled:!1,lazyloadSrcAttr:"data-src",lazyloadClass:"lazyload",lazyloadSrcSetAttr:"data-srcset",lazyloadThreshold:300,lazyloadThrottle:150,useCache:!0,classFactory:null,graphicLoader:null,transitionFactory:null},M=function(){function t(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};(0,u.default)(this,t),this.options=(0,i.default)({},A,e),window.location.origin||(window.location.origin=window.location.protocol+"//"+window.location.host),this.transitionFactory=null,this.loader=this.options.graphicLoader?this.options.graphicLoader:new j.default,this.classFactory=this.options.classFactory?this.options.classFactory:new L.default,this.options.ajaxEnabled&&window.fetch&&(this.transitionFactory=this.options.transitionFactory||new g.default),this.baseUrl=window.location.origin,this.page=null,this.prefetch=null,this.cacheProvider=null,this.history=null,this.dom=null,this.pjax=null,this.$body=(0,f.default)(document.body),this.buildPage=this.buildPage.bind(this)}return(0,c.default)(t,[{key:"init",value:function(){if(this.dom=new P.default(this.$body,{wrapperId:this.options.ajaxWrapperId,objectTypeAttr:this.options.objectTypeAttr,containerClass:this.options.pageClass}),this.options.ajaxEnabled&&window.fetch){this.cacheProvider=new h.default,this.history=new k.default;var t={ignoreClassLink:this.options.noAjaxLinkClass,cacheEnabled:this.options.useCache,workerEnabled:this.options.workerEnabled};this.pjax=new x.default(this,this.history,this.dom,this.cacheProvider,this.transitionFactory,this.loader,t),this.pjax.init()}this.options.ajaxEnabled&&window.fetch&&this.options.prefetchEnabled&&(this.prefetch=new _.default(this.pjax,this.cacheProvider,{cacheEnabled:this.options.useCache,workerEnabled:this.options.workerEnabled,noPrefetchLinkClass:this.options.noPrefetchLinkClass}),this.prefetch.init()),this.buildPage(this.dom.getContainer(),"static"),this.initEvents()}},{key:"initEvents",value:function(){}},{key:"buildPage",value:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:"ajax";if(!t)throw new Error("Router: container not found!");return this.page=this.classFactory.getPageInstance(this,t,e,this.dom.getNodeType(t)),this.page.init(),v.default.commit(m.AFTER_PAGE_BOOT,this.page),this.page}}]),t}();e.default=M},function(t,e,n){"use strict";e.__esModule=!0;var r=n(77),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=o.default||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}},function(t,e,n){t.exports={default:n(78),__esModule:!0}},function(t,e,n){n(79),t.exports=n(2).Object.assign},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(80)})},function(t,e,n){"use strict";var r=n(21),o=n(37),i=n(23),a=n(24),u=n(48),s=Object.assign;t.exports=!s||n(13)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=s({},t)[n]||Object.keys(s({},e)).join("")!=r})?function(t,e){for(var n=a(t),s=arguments.length,c=1,l=o.f,f=i.f;s>c;)for(var d,h=u(arguments[c++]),p=l?r(h).concat(l(h)):r(h),v=p.length,y=0;v>y;)f.call(h,d=p[y++])&&(n[d]=h[d]);return n}:s},function(t,e,n){var r=n(14),o=n(32),i=n(82);t.exports=function(t){return function(e,n,a){var u,s=r(e),c=o(s.length),l=i(a,c);if(t&&n!=n){for(;c>l;)if((u=s[l++])!=u)return!0}else for(;c>l;l++)if((t||l in s)&&s[l]===n)return t||l||0;return!t&&-1}}},function(t,e,n){var r=n(33),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},function(t,e,n){t.exports={default:n(84),__esModule:!0}},function(t,e,n){n(85);var r=n(2).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){var r=n(5);r(r.S+r.F*!n(9),"Object",{defineProperty:n(6).f})},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(50),c=r(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(){(0,i.default)(this,t)}return(0,u.default)(t,[{key:"getTransition",value:function(t,e){if(e&&"history"===e.context)return new c.default;return e.transitionName,new c.default}}]),t}();e.default=l},function(t,e,n){n(51),n(40),n(56),n(94),n(101),n(102),t.exports=n(2).Promise},function(t,e,n){var r=n(33),o=n(31);t.exports=function(t){return function(e,n){var i,a,u=String(o(e)),s=r(n),c=u.length;return s<0||s>=c?t?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===c||(a=u.charCodeAt(s+1))<56320||a>57343?t?u.charAt(s):i:t?u.slice(s,s+2):a-56320+(i-55296<<10)+65536)}}},function(t,e,n){"use strict";var r=n(41),o=n(16),i=n(27),a={};n(10)(a,n(4)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){var r=n(6),o=n(7),i=n(21);t.exports=n(9)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),u=a.length,s=0;u>s;)r.f(t,n=a[s++],e[n]);return t}},function(t,e,n){"use strict";var r=n(92),o=n(93),i=n(18),a=n(14);t.exports=n(52)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,n):"values"==e?o(0,t[n]):o(0,[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var r,o,i,a,u=n(26),s=n(3),c=n(12),l=n(57),f=n(5),d=n(8),h=n(20),p=n(95),v=n(96),y=n(61),g=n(62).set,m=n(98)(),w=n(42),_=n(63),b=n(64),k=s.TypeError,E=s.process,x=s.Promise,O="process"==l(E),P=function(){},S=o=w.f,L=!!function(){try{var t=x.resolve(1),e=(t.constructor={})[n(4)("species")]=function(t){t(P,P)};return(O||"function"==typeof PromiseRejectionEvent)&&t.then(P)instanceof e}catch(t){}}(),T=function(t){var e;return!(!d(t)||"function"!=typeof(e=t.then))&&e},j=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var r=t._v,o=1==t._s,i=0;n.length>i;)!function(e){var n,i,a,u=o?e.ok:e.fail,s=e.resolve,c=e.reject,l=e.domain;try{u?(o||(2==t._h&&R(t),t._h=1),!0===u?n=r:(l&&l.enter(),n=u(r),l&&(l.exit(),a=!0)),n===e.promise?c(k("Promise-chain cycle")):(i=T(n))?i.call(n,s,c):s(n)):c(r)}catch(t){l&&!a&&l.exit(),c(t)}}(n[i++]);t._c=[],t._n=!1,e&&!t._h&&A(t)})}},A=function(t){g.call(s,function(){var e,n,r,o=t._v,i=M(t);if(i&&(e=_(function(){O?E.emit("unhandledRejection",o,t):(n=s.onunhandledrejection)?n({promise:t,reason:o}):(r=s.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=O||M(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},M=function(t){return 1!==t._h&&0===(t._a||t._c).length},R=function(t){g.call(s,function(){var e;O?E.emit("rejectionHandled",t):(e=s.onrejectionhandled)&&e({promise:t,reason:t._v})})},C=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),j(e,!0))},F=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw k("Promise can't be resolved itself");(e=T(t))?m(function(){var r={_w:n,_d:!1};try{e.call(t,c(F,r,1),c(C,r,1))}catch(t){C.call(r,t)}}):(n._v=t,n._s=1,j(n,!1))}catch(t){C.call({_w:n,_d:!1},t)}}};L||(x=function(t){p(this,x,"Promise","_h"),h(t),r.call(this);try{t(c(F,this,1),c(C,this,1))}catch(t){C.call(this,t)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n(99)(x.prototype,{then:function(t,e){var n=S(y(this,x));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=O?E.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&j(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=c(F,t,1),this.reject=c(C,t,1)},w.f=S=function(t){return t===x||t===a?new i(t):o(t)}),f(f.G+f.W+f.F*!L,{Promise:x}),n(27)(x,"Promise"),n(100)("Promise"),a=n(2).Promise,f(f.S+f.F*!L,"Promise",{reject:function(t){var e=S(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!L),"Promise",{resolve:function(t){return b(u&&this===a?x:this,t)}}),f(f.S+f.F*!(L&&n(65)(function(t){x.all(t).catch(P)})),"Promise",{all:function(t){var e=this,n=S(e),r=n.resolve,o=n.reject,i=_(function(){var n=[],i=0,a=1;v(t,!1,function(t){var u=i++,s=!1;n.push(void 0),a++,e.resolve(t).then(function(t){s||(s=!0,n[u]=t,--a||r(n))},o)}),--a||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=S(e),r=n.reject,o=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(12),o=n(58),i=n(59),a=n(7),u=n(32),s=n(60),c={},l={},e=t.exports=function(t,e,n,f,d){var h,p,v,y,g=d?function(){return t}:s(t),m=r(n,f,e?2:1),w=0;if("function"!=typeof g)throw TypeError(t+" is not iterable!");if(i(g)){for(h=u(t.length);h>w;w++)if((y=e?m(a(p=t[w])[0],p[1]):m(t[w]))===c||y===l)return y}else for(v=g.call(t);!(p=v.next()).done;)if((y=o(v,m,p.value,e))===c||y===l)return y};e.BREAK=c,e.RETURN=l},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(3),o=n(62).set,i=r.MutationObserver||r.WebKitMutationObserver,a=r.process,u=r.Promise,s="process"==n(17)(a);t.exports=function(){var t,e,n,c=function(){var r,o;for(s&&(r=a.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(s)n=function(){a.nextTick(c)};else if(!i||r.navigator&&r.navigator.standalone)if(u&&u.resolve){var l=u.resolve();n=function(){l.then(c)}}else n=function(){o.call(r,c)};else{var f=!0,d=document.createTextNode("");new i(c).observe(d,{characterData:!0}),n=function(){d.data=f=!f}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(10);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){"use strict";var r=n(3),o=n(2),i=n(6),a=n(9),u=n(4)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];a&&e&&!e[u]&&i.f(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,n){"use strict";var r=n(5),o=n(2),i=n(3),a=n(61),u=n(64);r(r.P+r.R,"Promise",{finally:function(t){var e=a(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var r=n(5),o=n(42),i=n(63);r(r.S,"Promise",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){t.exports={default:n(104),__esModule:!0}},function(t,e,n){n(105),t.exports=n(2).Object.getPrototypeOf},function(t,e,n){var r=n(24),o=n(55);n(106)("getPrototypeOf",function(){return function(t){return o(r(t))}})},function(t,e,n){var r=n(5),o=n(2),i=n(13);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],a={};a[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(66),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!==(void 0===e?"undefined":(0,o.default)(e))&&"function"!=typeof e?t:e}},function(t,e,n){t.exports={default:n(109),__esModule:!0}},function(t,e,n){n(40),n(56),t.exports=n(43).f("iterator")},function(t,e,n){t.exports={default:n(111),__esModule:!0}},function(t,e,n){n(112),n(51),n(117),n(118),t.exports=n(2).Symbol},function(t,e,n){"use strict";var r=n(3),o=n(11),i=n(9),a=n(5),u=n(53),s=n(113).KEY,c=n(13),l=n(35),f=n(27),d=n(22),h=n(4),p=n(43),v=n(44),y=n(114),g=n(115),m=n(7),w=n(8),_=n(14),b=n(30),k=n(16),E=n(41),x=n(116),O=n(68),P=n(6),S=n(21),L=O.f,T=P.f,j=x.f,A=r.Symbol,M=r.JSON,R=M&&M.stringify,C=h("_hidden"),F=h("toPrimitive"),N={}.propertyIsEnumerable,I=l("symbol-registry"),z=l("symbols"),B=l("op-symbols"),D=Object.prototype,H="function"==typeof A,G=r.QObject,$=!G||!G.prototype||!G.prototype.findChild,q=i&&c(function(){return 7!=E(T({},"a",{get:function(){return T(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=L(D,e);r&&delete D[e],T(t,e,n),r&&t!==D&&T(D,e,r)}:T,W=function(t){var e=z[t]=E(A.prototype);return e._k=t,e},U=H&&"symbol"==typeof A.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof A},V=function(t,e,n){return t===D&&V(B,e,n),m(t),e=b(e,!0),m(n),o(z,e)?(n.enumerable?(o(t,C)&&t[C][e]&&(t[C][e]=!1),n=E(n,{enumerable:k(0,!1)})):(o(t,C)||T(t,C,k(1,{})),t[C][e]=!0),q(t,e,n)):T(t,e,n)},J=function(t,e){m(t);for(var n,r=y(e=_(e)),o=0,i=r.length;i>o;)V(t,n=r[o++],e[n]);return t},X=function(t,e){return void 0===e?E(t):J(E(t),e)},Y=function(t){var e=N.call(this,t=b(t,!0));return!(this===D&&o(z,t)&&!o(B,t))&&(!(e||!o(this,t)||!o(z,t)||o(this,C)&&this[C][t])||e)},K=function(t,e){if(t=_(t),e=b(e,!0),t!==D||!o(z,e)||o(B,e)){var n=L(t,e);return!n||!o(z,e)||o(t,C)&&t[C][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=j(_(t)),r=[],i=0;n.length>i;)o(z,e=n[i++])||e==C||e==s||r.push(e);return r},Z=function(t){for(var e,n=t===D,r=j(n?B:_(t)),i=[],a=0;r.length>a;)!o(z,e=r[a++])||n&&!o(D,e)||i.push(z[e]);return i};H||(A=function(){if(this instanceof A)throw TypeError("Symbol is not a constructor!");var t=d(arguments.length>0?arguments[0]:void 0),e=function(n){this===D&&e.call(B,n),o(this,C)&&o(this[C],t)&&(this[C][t]=!1),q(this,t,k(1,n))};return i&&$&&q(D,t,{configurable:!0,set:e}),W(t)},u(A.prototype,"toString",function(){return this._k}),O.f=K,P.f=V,n(67).f=x.f=Q,n(23).f=Y,n(37).f=Z,i&&!n(26)&&u(D,"propertyIsEnumerable",Y,!0),p.f=function(t){return W(h(t))}),a(a.G+a.W+a.F*!H,{Symbol:A});for(var tt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),et=0;tt.length>et;)h(tt[et++]);for(var nt=S(h.store),rt=0;nt.length>rt;)v(nt[rt++]);a(a.S+a.F*!H,"Symbol",{for:function(t){return o(I,t+="")?I[t]:I[t]=A(t)},keyFor:function(t){if(!U(t))throw TypeError(t+" is not a symbol!");for(var e in I)if(I[e]===t)return e},useSetter:function(){$=!0},useSimple:function(){$=!1}}),a(a.S+a.F*!H,"Object",{create:X,defineProperty:V,defineProperties:J,getOwnPropertyDescriptor:K,getOwnPropertyNames:Q,getOwnPropertySymbols:Z}),M&&a(a.S+a.F*(!H||c(function(){var t=A();return"[null]"!=R([t])||"{}"!=R({a:t})||"{}"!=R(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(w(e)||void 0!==t)&&!U(t))return g(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!U(e))return e}),r[1]=e,R.apply(M,r)}}),A.prototype[F]||n(10)(A.prototype,F,A.prototype.valueOf),f(A,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(t,e,n){var r=n(22)("meta"),o=n(8),i=n(11),a=n(6).f,u=0,s=Object.isExtensible||function(){return!0},c=!n(13)(function(){return s(Object.preventExtensions({}))}),l=function(t){a(t,r,{value:{i:"O"+ ++u,w:{}}})},f=function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!s(t))return"F";if(!e)return"E";l(t)}return t[r].i},d=function(t,e){if(!i(t,r)){if(!s(t))return!0;if(!e)return!1;l(t)}return t[r].w},h=function(t){return c&&p.NEED&&s(t)&&!i(t,r)&&l(t),t},p=t.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:h}},function(t,e,n){var r=n(21),o=n(37),i=n(23);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,u=n(t),s=i.f,c=0;u.length>c;)s.call(t,a=u[c++])&&e.push(a);return e}},function(t,e,n){var r=n(17);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(14),o=n(67).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(t){try{return o(t)}catch(t){return a.slice()}};t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?u(t):o(r(t))}},function(t,e,n){n(44)("asyncIterator")},function(t,e,n){n(44)("observable")},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var o=n(120),i=r(o),a=n(124),u=r(a),s=n(66),c=r(s);e.default=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+(void 0===e?"undefined":(0,c.default)(e)));t.prototype=(0,u.default)(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(i.default?(0,i.default)(t,e):t.__proto__=e)}},function(t,e,n){t.exports={default:n(121),__esModule:!0}},function(t,e,n){n(122),t.exports=n(2).Object.setPrototypeOf},function(t,e,n){var r=n(5);r(r.S,"Object",{setPrototypeOf:n(123).set})},function(t,e,n){var r=n(8),o=n(7),i=function(t,e){if(o(t),!r(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,r){try{r=n(12)(Function.call,n(68).f(Object.prototype,"__proto__").set,2),r(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return i(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:i}},function(t,e,n){t.exports={default:n(125),__esModule:!0}},function(t,e,n){n(126);var r=n(2).Object;t.exports=function(t,e){return r.create(t,e)}},function(t,e,n){var r=n(5);r(r.S,"Object",{create:n(41)})},function(t,e,n){function r(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.r=function(t){Object.defineProperty(t,"__esModule",{value:!0})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e.oe=function(t){throw console.error(t),t};var r=e(e.s=ENTRY_MODULE);return r.default||r}function o(t){return(t+"").replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}function i(t,e,r){var i={};i[r]=[];var a=e.toString(),u=a.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);if(!u)return i;for(var l,f=u[1],d=new RegExp("(\\\\n|\\W)"+o(f)+c,"g");l=d.exec(a);)"dll-reference"!==l[3]&&i[r].push(l[3]);for(d=new RegExp("\\("+o(f)+'\\("(dll-reference\\s('+s+'))"\\)\\)'+c,"g");l=d.exec(a);)t[l[2]]||(i[r].push(l[1]),t[l[2]]=n(l[1]).m),i[l[2]]=i[l[2]]||[],i[l[2]].push(l[4]);return i}function a(t){return Object.keys(t).reduce(function(e,n){return e||t[n].length>0},!1)}function u(t,e){for(var n={main:[e]},r={main:[]},o={main:{}};a(n);)for(var u=Object.keys(n),s=0;s<u.length;s++){var c=u[s],l=n[c],f=l.pop();if(o[c]=o[c]||{},!o[c][f]&&t[c][f]){o[c][f]=!0,r[c]=r[c]||[],r[c].push(f);for(var d=i(t,t[c][f],c),h=Object.keys(d),p=0;p<h.length;p++)n[h[p]]=n[h[p]]||[],n[h[p]]=n[h[p]].concat(d[h[p]])}}return r}var s="[\\.|\\-|\\+|\\w|/|@]+",c="\\((/\\*.*?\\*/)?s?.*?("+s+").*?\\)";t.exports=function(t,e){e=e||{};var o={main:n.m},i=e.all?{main:Object.keys(o)}:u(o,t),a="";Object.keys(i).filter(function(t){return"main"!==t}).forEach(function(t){for(var e=0;i[t][e];)e++;i[t].push(e),o[t][e]="(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })",a=a+"var "+t+" = ("+r.toString().replace("ENTRY_MODULE",JSON.stringify(e))+")({"+i[t].map(function(e){return JSON.stringify(e)+": "+o[t][e].toString()}).join(",")+"});\n"}),a=a+"("+r.toString().replace("ENTRY_MODULE",JSON.stringify(t))+")({"+i.main.map(function(t){return JSON.stringify(t)+": "+o.main[t].toString()}).join(",")+"})(self);";var s=new window.Blob([a],{type:"text/javascript"});if(e.bare)return s;var c=window.URL||window.webkitURL||window.mozURL||window.msURL,l=c.createObjectURL(s),f=new window.Worker(l);return f.objectURL=l,f}},function(t,e,n){"use strict";var r=n(70),o=function(t){return t&&t.__esModule?t:{default:t}}(r);Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(){self.addEventListener("message",function(t){var e=t.data.url,n=new XMLHttpRequest;n.open("GET",e,!1),n.setRequestHeader("X-Starting-Blocks","yes"),n.setRequestHeader("X-Allow-Partial","yes"),n.setRequestHeader("X-Requested-With","XMLHttpRequest"),n.withCredentials=!0,n.send(null),200===n.status?self.postMessage((0,o.default)({res:n.responseText})):self.postMessage((0,o.default)({err:n.statusText,status:n.status}))})}},function(t,e,n){var r=n(2),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(19),c=r(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(e,n){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},o=r.ignoreClassLink,a=void 0===o?"no-prefetch":o,u=r.workerEnabled,s=r.cacheEnabled;(0,i.default)(this,t),this.ignoreClassLink=a,this.cacheEnabled=void 0===s||s,this.workerEnabled=void 0!==u&&u,this.pjax=e,this.cacheProvider=n}return(0,u.default)(t,[{key:"init",value:function(){return!!window.history.pushState&&(document.body.addEventListener("mouseover",this.onLinkEnter.bind(this)),void document.body.addEventListener("touchstart",this.onLinkEnter.bind(this)))}},{key:"onLinkEnter",value:function(t){for(var e=t.target;e&&!this.pjax.getHref(e);)e=e.parentNode;if(e&&!e.classList.contains(this.ignoreClassLink)){var n=this.pjax.getHref(e);if(this.pjax.preventCheck(t,e)&&!this.cacheProvider.get(n)){var r=c.default.request(n,this.workerEnabled);this.cacheEnabled&&this.cacheProvider.set(n,r)}}}}]),t}();e.default=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a);Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(){(0,i.default)(this,t),this.history=[]}return(0,u.default)(t,[{key:"add",value:function(t,e,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},o={url:t,transitionName:e,context:n,data:r};return this.history.push(o),o}},{key:"currentStatus",value:function(){return this.history[this.history.length-1]}},{key:"prevStatus",value:function(){var t=this.history;return 2>t.length?null:t[t.length-2]}}]),t}();e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(19),c=r(s),l=n(38),f=r(l),d=n(28);Object.defineProperty(e,"__esModule",{value:!0});var h=function(){function t(e,n,r,o,a,u){var s=6<arguments.length&&void 0!==arguments[6]?arguments[6]:{},c=s.ignoreClassLink,l=void 0===c?"no-ajax-link":c,f=s.workerEnabled,d=s.cacheEnabled;if((0,i.default)(this,t),this.router=e,this.history=n,this.dom=r,this.cache=o,this.transitionFactory=a,!(this.router&&this.history&&this.dom&&this.cache&&this.transitionFactory))throw new Error("Starting Blocks: a Pjax parameter is missing!");this.loader=u,this.cacheEnabled=void 0===d||d,this.workerEnabled=void 0!==f&&f,this.ignoreClassLink=l,this.transitionProgress=!1,this.onNewPageLoaded=this.onNewPageLoaded.bind(this),this.onTransitionEnd=this.onTransitionEnd.bind(this),this.onLinkClick=this.onLinkClick.bind(this),this.onStateChange=this.onStateChange.bind(this)}return(0,u.default)(t,[{key:"init",value:function(){this.dom.getWrapper().setAttribute("aria-live","polite"),this.currentState=this.history.add(this.getCurrentUrl(),null,"static"),this.bindEvents()}},{key:"bindEvents",value:function(){document.addEventListener("click",this.onLinkClick),window.addEventListener("popstate",this.onStateChange)}},{key:"getCurrentUrl",value:function(){return c.default.cleanLink(c.default.getCurrentUrl())}},{key:"goTo",value:function(t,e){var n=window.scrollY;window.history.pushState(null,null,t),window.scrollTo(0,n),this.onStateChange(e,!0)}},{key:"forceGoTo",value:function(t){window.location=t}},{key:"load",value:function(t){var e=this,n=c.default.deferred();this.loader&&this.loader.show();var r=this.cache.get(t);return r||(r=c.default.request(t,this.workerEnabled),this.cache.set(t,r)),r.then(function(t){var r=e.dom.parseResponse(t);f.default.commit(d.AFTER_PAGE_LOAD,{container:r,currentHTML:e.dom.currentHTML}),e.dom.putContainer(r),f.default.commit(d.AFTER_DOM_APPENDED,{container:r,currentHTML:e.dom.currentHTML});var o=e.router.buildPage(r);e.cacheEnabled||e.cache.reset(),n.resolve(o)}).catch(function(r){console.error(r),e.forceGoTo(t),n.reject()}),n.promise}},{key:"getHref",value:function(t){return t?t.getAttribute&&"string"==typeof t.getAttribute("xlink:href")?t.getAttribute("xlink:href"):"string"==typeof t.href?t.href:void 0:void 0}},{key:"getTransitionName",value:function(t){return t&&t.getAttribute&&"string"==typeof t.getAttribute("data-transition")?t.getAttribute("data-transition"):null}},{key:"onLinkClick",value:function(t){for(var e=t.target;e&&!this.getHref(e);)e=e.parentNode;if(this.preventCheck(t,e)){t.preventDefault(),this.linkHash=e.hash.split("#")[1];var n=this.getHref(e),r=this.getTransitionName(e);this.goTo(n,r)}}},{key:"preventCheck",value:function(t,e){if(!window.history.pushState)return!1;var n=this.getHref(e);return!(!e||!n||1<t.which||t.metaKey||t.ctrlKey||t.shiftKey||t.altKey||e.target&&"_blank"===e.target||window.location.protocol!==e.protocol||window.location.hostname!==e.hostname||c.default.getPort()!==c.default.getPort(e.port)||e.getAttribute&&"string"==typeof e.getAttribute("download")||c.default.cleanLink(n)===c.default.cleanLink(window.location.href)||e.classList.contains(this.ignoreClassLink))}},{key:"getTransition",value:function(t,e){return this.transitionFactory.getTransition(t,e)}},{key:"onStateChange",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,e=!!(1<arguments.length&&void 0!==arguments[1])&&arguments[1],n=this.getCurrentUrl();if(this.transitionProgress&&this.forceGoTo(n),this.history.currentStatus().url===n)return!1;this.currentState="string"==typeof t||e?this.history.add(n,t,"ajax"):this.history.add(n,null,"history"),f.default.commit(d.BEFORE_PAGE_LOAD,{currentStatus:this.history.currentStatus(),prevStatus:this.history.prevStatus()});var r=this.load(n),o=this.getTransition(this.history.prevStatus(),this.history.currentStatus());this.transitionProgress=!0,f.default.commit(d.TRANSITION_START,{transition:o,currentStatus:this.history.currentStatus(),prevStatus:this.history.prevStatus()});var i=o.init(this.router.page,r);r.then(this.onNewPageLoaded),i.then(this.onTransitionEnd)}},{key:"onNewPageLoaded",value:function(t){var e=this.history.currentStatus();this.loader&&this.loader.hide(),this.dom.updateBodyAttributes(t),this.dom.updatePageTitle(t),c.default.trackGoogleAnalytics(),this.currentState&&t&&!this.currentState.data.title&&t.metaTitle&&(this.currentState.data.title=t.metaTitle),f.default.commit(d.CONTAINER_READY,{currentStatus:e,prevStatus:this.history.prevStatus(),currentHTML:this.dom.currentHTML,page:t})}},{key:"onTransitionEnd",value:function(){this.transitionProgress=!1,this.linkHash&&(window.location.hash="",window.location.hash=this.linkHash,this.linkHash=null),f.default.commit(d.TRANSITION_COMPLETE,{currentStatus:this.history.currentStatus(),prevStatus:this.history.prevStatus()})}}]),t}();e.default=h},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a);Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(e){var n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},r=n.wrapperId,o=void 0===r?"sb-wrapper":r,a=n.objectTypeAttr,u=void 0===a?"data-node-type":a,s=n.pageClass,c=void 0===s?"page-content":s;(0,i.default)(this,t),this.wrapperId=o,this.objectTypeAttr=u,this.pageClass=c,this.currentHTML=document.documentElement.innerHTML,this.$body=e}return(0,u.default)(t,[{key:"parseResponse",value:function(t){this.currentHTML=t;var e=document.createElement("div");return e.innerHTML=t,this.getContainer(e)}},{key:"getWrapper",value:function(){var t=document.getElementById(this.wrapperId);if(!t)throw new Error("Starting Blocks: Wrapper not found!");return t}},{key:"getNodeType",value:function(t){return t.getAttribute(this.objectTypeAttr)}},{key:"getContainer",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null;if(t||(t=document.body),!t)throw new Error("Starting Blocks: DOM not ready!");var e=this.parseContainer(t);if(!e)throw new Error("Starting Blocks: no container found");return e}},{key:"putContainer",value:function(t){t.style.visibility="hidden",this.getWrapper().appendChild(t)}},{key:"parseContainer",value:function(t){return t.querySelector("."+this.pageClass)}},{key:"updateBodyAttributes",value:function(t){t.name&&(document.body.id=t.name,this.$body.addClass(t.name)),t.isHome?this.$body.attr("data-is-home",1):this.$body.attr("data-is-home",0),this.$body.addClass(t.type)}},{key:"updatePageTitle",value:function(t){t.metaTitle&&(document.title=t.metaTitle)}}]),t}();e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(15),c=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(s),l=n(71),f=r(l);Object.defineProperty(e,"__esModule",{value:!0});var d=function(){function t(){(0,i.default)(this,t)}return(0,u.default)(t,[{key:"getPageInstance",value:function(t,e,n,r){return c.info('"'+r+'" has no defined route, using Page.'),new f.default(t,e,n,r)}},{key:"getBlockInstance",value:function(){}}]),t}();e.default=d},function(t,e,n){t.exports=n(136)},function(t,e,n){var r=function(){return this}()||Function("return this")(),o=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime")>=0,i=o&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,t.exports=n(137),o)r.regeneratorRuntime=i;else try{delete r.regeneratorRuntime}catch(t){r.regeneratorRuntime=void 0}},function(t,e){!function(e){"use strict";function n(t,e,n,r){var i=e&&e.prototype instanceof o?e:o,a=Object.create(i.prototype),u=new h(r||[]);return a._invoke=c(t,n,u),a}function r(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}function o(){}function i(){}function a(){}function u(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function s(t){function e(n,o,i,a){var u=r(t[n],t,o);if("throw"!==u.type){var s=u.arg,c=s.value;return c&&"object"==typeof c&&m.call(c,"__await")?Promise.resolve(c.__await).then(function(t){e("next",t,i,a)},function(t){e("throw",t,i,a)}):Promise.resolve(c).then(function(t){s.value=t,i(s)},a)}a(u.arg)}function n(t,n){function r(){return new Promise(function(r,o){e(t,n,r,o)})}return o=o?o.then(r,r):r()}var o;this._invoke=n}function c(t,e,n){var o=O;return function(i,a){if(o===S)throw new Error("Generator is already running");if(o===L){if("throw"===i)throw a;return v()}for(n.method=i,n.arg=a;;){var u=n.delegate;if(u){var s=l(u,n);if(s){if(s===T)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===O)throw o=L,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=S;var c=r(t,e,n);if("normal"===c.type){if(o=n.done?L:P,c.arg===T)continue;return{value:c.arg,done:n.done}}"throw"===c.type&&(o=L,n.method="throw",n.arg=c.arg)}}}function l(t,e){var n=t.iterator[e.method];if(n===y){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=y,l(t,e),"throw"===e.method))return T;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return T}var o=r(n,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,T;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=y),e.delegate=null,T):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,T)}function f(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function d(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function h(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(f,this),this.reset(!0)}function p(t){if(t){var e=t[_];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,r=function e(){for(;++n<t.length;)if(m.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=y,e.done=!0,e};return r.next=r}}return{next:v}}function v(){return{value:y,done:!0}}var y,g=Object.prototype,m=g.hasOwnProperty,w="function"==typeof Symbol?Symbol:{},_=w.iterator||"@@iterator",b=w.asyncIterator||"@@asyncIterator",k=w.toStringTag||"@@toStringTag",E="object"==typeof t,x=e.regeneratorRuntime;if(x)return void(E&&(t.exports=x));x=e.regeneratorRuntime=E?t.exports:{},x.wrap=n;var O="suspendedStart",P="suspendedYield",S="executing",L="completed",T={},j={};j[_]=function(){return this};var A=Object.getPrototypeOf,M=A&&A(A(p([])));M&&M!==g&&m.call(M,_)&&(j=M);var R=a.prototype=o.prototype=Object.create(j);i.prototype=R.constructor=a,a.constructor=i,a[k]=i.displayName="GeneratorFunction",x.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===i||"GeneratorFunction"===(e.displayName||e.name))},x.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,a):(t.__proto__=a,k in t||(t[k]="GeneratorFunction")),t.prototype=Object.create(R),t},x.awrap=function(t){return{__await:t}},u(s.prototype),s.prototype[b]=function(){return this},x.AsyncIterator=s,x.async=function(t,e,r,o){var i=new s(n(t,e,r,o));return x.isGeneratorFunction(e)?i:i.next().then(function(t){return t.done?t.value:i.next()})},u(R),R[k]="Generator",R[_]=function(){return this},R.toString=function(){return"[object Generator]"},x.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},x.values=p,h.prototype={constructor:h,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=y,this.done=!1,this.delegate=null,this.method="next",this.arg=y,this.tryEntries.forEach(d),!t)for(var e in this)"t"===e.charAt(0)&&m.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=y)},stop:function(){this.done=!0;var t=this.tryEntries[0],e=t.completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(t){function e(e,r){return i.type="throw",i.arg=t,n.next=e,r&&(n.method="next",n.arg=y),!!r}if(this.done)throw t;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r],i=o.completion;if("root"===o.tryLoc)return e("end");if(o.tryLoc<=this.prev){var a=m.call(o,"catchLoc"),u=m.call(o,"finallyLoc");if(a&&u){if(this.prev<o.catchLoc)return e(o.catchLoc,!0);if(this.prev<o.finallyLoc)return e(o.finallyLoc)}else if(a){if(this.prev<o.catchLoc)return e(o.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return e(o.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&m.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,T):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),T},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),d(n),T}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var o=r.arg;d(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:p(t),resultName:e,nextLoc:n},"next"===this.method&&(this.arg=y),T}}}(function(){return this}()||Function("return this")())},function(t,e,n){"use strict";e.__esModule=!0;var r=n(39),o=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t){return function(){var e=t.apply(this,arguments);return new o.default(function(t,n){function r(i,a){try{var u=e[i](a),s=u.value}catch(t){return void n(t)}if(!u.done)return o.default.resolve(s).then(function(t){r("next",t)},function(t){r("throw",t)});t(s)}return r("next")})}}},function(t,e,n){var r,o,i;!function(n,a){o=[],r=a,void 0!==(i="function"==typeof r?r.apply(e,o):r)&&(t.exports=i)}(0,function(){function t(){g||(h={elements_selector:"img",container:window,threshold:300,throttle:50,data_src:"original",data_srcset:"original-set",class_loading:"loading",class_loaded:"loaded",skip_invisible:!0,callback_load:null,callback_error:null,callback_set:null,callback_processed:null},p=!!window.addEventListener,v=!!window.attachEvent,y=!!document.body.classList,g=!0)}function e(t,e,n){return p?void t.addEventListener(e,n):void(v&&(t.attachEvent("on"+e,function(t){return function(){n.call(t,window.event)}}(t)),t=null))}function n(t,e,n){return p?void t.removeEventListener(e,n):void(v&&t.detachEvent("on"+e,n))}function r(t,e,n){function r(){return window.innerWidth||u.documentElement.clientWidth||document.body.clientWidth}function o(){return window.innerHeight||u.documentElement.clientHeight||document.body.clientHeight}function i(t){return t.getBoundingClientRect().top+s-u.documentElement.clientTop}function a(t){return t.getBoundingClientRect().left+c-u.documentElement.clientLeft}var u,s,c;return u=t.ownerDocument,s=window.pageYOffset||u.body.scrollTop,c=window.pageXOffset||u.body.scrollLeft,!(function(){return(e===window?o()+s:i(e)+e.offsetHeight)<=i(t)-n}()||function(){return(e===window?s:i(e))>=i(t)+n+t.offsetHeight}()||function(){return(e===window?r()+window.pageXOffset:a(e)+r())<=a(t)-n}()||function(){return(e===window?c:a(e))>=a(t)+n+t.offsetWidth}())}function o(){return(new Date).getTime()}function i(t,e){var n,r={};for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);for(n in e)e.hasOwnProperty(n)&&(r[n]=e[n]);return r}function a(t){try{return Array.prototype.slice.call(t)}catch(o){var e,n=[],r=t.length;for(e=0;r>e;e++)n.push(t[e]);return n}}function u(t,e){return y?void t.classList.add(e):void(t.className+=(t.className?" ":"")+e)}function s(t,e){return y?void t.classList.remove(e):void(t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,""))}function c(t,e){var n=t.parentElement;if("PICTURE"===n.tagName)for(var r=0;r<n.children.length;r++){var o=n.children[r];if("SOURCE"===o.tagName){var i=o.getAttribute("data-"+e);i&&o.setAttribute("srcset",i)}}}function l(t,e,n){var r=t.tagName,o=t.getAttribute("data-"+n);if("IMG"===r){c(t,e);var i=t.getAttribute("data-"+e);return i&&t.setAttribute("srcset",i),void(o&&t.setAttribute("src",o))}return"IFRAME"===r?void(o&&t.setAttribute("src",o)):void(t.style.backgroundImage="url("+o+")")}function f(t,e){return function(){return t.apply(e,arguments)}}function d(n){t(),this._settings=i(h,n),this._queryOriginNode=this._settings.container===window?document:this._settings.container,this._previousLoopTime=0,this._loopTimeout=null,this._handleScrollFn=f(this.handleScroll,this),e(window,"resize",this._handleScrollFn),this.update()}var h,p,v,y,g=!1;return d.prototype._showOnAppear=function(t){function r(){null!==o&&(o.callback_load&&o.callback_load(t),s(t,o.class_loading),u(t,o.class_loaded),n(t,"load",r))}var o=this._settings;("IMG"===t.tagName||"IFRAME"===t.tagName)&&(e(t,"load",r),e(t,"error",function(){n(t,"load",r),s(t,o.class_loading),o.callback_error&&o.callback_error(t)}),u(t,o.class_loading)),l(t,o.data_srcset,o.data_src),o.callback_set&&o.callback_set(t)},d.prototype._loopThroughElements=function(){var t,e,n=this._settings,o=this._elements,i=o?o.length:0,a=[];for(t=0;i>t;t++)e=o[t],n.skip_invisible&&null===e.offsetParent||r(e,n.container,n.threshold)&&(this._showOnAppear(e),a.push(t),e.wasProcessed=!0);for(;a.length>0;)o.splice(a.pop(),1),n.callback_processed&&n.callback_processed(o.length);0===i&&this._stopScrollHandler()},d.prototype._purgeElements=function(){var t,e,n=this._elements,r=n.length,o=[];for(t=0;r>t;t++)e=n[t],e.wasProcessed&&o.push(t);for(;o.length>0;)n.splice(o.pop(),1)},d.prototype._startScrollHandler=function(){this._isHandlingScroll||(this._isHandlingScroll=!0,e(this._settings.container,"scroll",this._handleScrollFn))},d.prototype._stopScrollHandler=function(){this._isHandlingScroll&&(this._isHandlingScroll=!1,n(this._settings.container,"scroll",this._handleScrollFn))},d.prototype.handleScroll=function(){var t,e,n;this._settings&&(e=o(),n=this._settings.throttle,0!==n?(t=n-(e-this._previousLoopTime),0>=t||t>n?(this._loopTimeout&&(clearTimeout(this._loopTimeout),this._loopTimeout=null),this._previousLoopTime=e,this._loopThroughElements()):this._loopTimeout||(this._loopTimeout=setTimeout(f(function(){this._previousLoopTime=o(),this._loopTimeout=null,this._loopThroughElements()},this),t))):this._loopThroughElements())},d.prototype.update=function(){this._elements=a(this._queryOriginNode.querySelectorAll(this._settings.elements_selector)),this._purgeElements(),this._loopThroughElements(),this._startScrollHandler()},d.prototype.destroy=function(){n(window,"resize",this._handleScrollFn),this._loopTimeout&&(clearTimeout(this._loopTimeout),this._loopTimeout=null),this._stopScrollHandler(),this._elements=null,this._queryOriginNode=null,this._settings=null},d})},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a);Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(){(0,i.default)(this,t)}return(0,u.default)(t,null,[{key:"_preventDefault",value:function(t){t=t||window.event,t.preventDefault&&t.preventDefault(),t.returnValue=!1}},{key:"_keydown",value:function(e){for(var n=[37,38,39,40,33,34,35],r=n.length;r--;)if(e.keyCode===n[r])return void t._preventDefault(e)}},{key:"_wheel",value:function(e){t._preventDefault(e)}},{key:"disable",value:function(){window.addEventListener&&window.addEventListener("DOMMouseScroll",t._wheel,!1),window.onmousewheel=document.onmousewheel=t._wheel,document.onkeydown=t._keydown}},{key:"enable",value:function(){window.removeEventListener&&window.removeEventListener("DOMMouseScroll",t._wheel,!1),window.onmousewheel=document.onmousewheel=document.onkeydown=null}}]),t}();e.default=s},function(t,e,n){"use strict";function r(){window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){window.setTimeout(t,1e3/60)}}(),window.cancelAnimFrame=function(){return window.cancelAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||window.oCancelAnimationFrame||window.msCancelAnimationFrame||function(t){window.clearTimeout(t)}}();for(var t,e=function(){},n=["assert","clear","count","debug","dir","dirxml","error","exception","group","groupCollapsed","groupEnd","info","log","markTimeline","profile","profileEnd","table","time","timeEnd","timeStamp","trace","warn"],r=n.length,o=window.console=window.console||{};r--;)t=n[r],o[t]||(o[t]=e);i.default||(Array.from=function(t){return[].slice.call(t)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null===this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var e=Object(this),n=e.length>>>0,r=arguments[1],o=void 0,i=0;i<n;i++)if(o=e[i],t.call(r,o,i,e))return o}}),Array.prototype.findIndex||Object.defineProperty(Array.prototype,"findIndex",{value:function(t){if(null===this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],o=0;o<n;){var i=e[o];if(t.call(r,i,o,e))return o;o++}return-1}}),function(){function t(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),n}"function"!=typeof window.CustomEvent&&(t.prototype=window.Event.prototype,window.CustomEvent=t)}()}var o=n(142),i=function(t){return t&&t.__esModule?t:{default:t}}(o);Object.defineProperty(e,"__esModule",{value:!0}),e.default=r},function(t,e,n){t.exports={default:n(143),__esModule:!0}},function(t,e,n){n(40),n(144),t.exports=n(2).Array.from},function(t,e,n){"use strict";var r=n(12),o=n(5),i=n(24),a=n(58),u=n(59),s=n(32),c=n(145),l=n(60);o(o.S+o.F*!n(65)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,o,f,d=i(t),h="function"==typeof this?this:Array,p=arguments.length,v=p>1?arguments[1]:void 0,y=void 0!==v,g=0,m=l(d);if(y&&(v=r(v,p>2?arguments[2]:void 0,2)),void 0==m||h==Array&&u(m))for(e=s(d.length),n=new h(e);e>g;g++)c(n,g,y?v(d[g],g):d[g]);else for(f=m.call(d),n=new h;!(o=f.next()).done;g++)c(n,g,y?a(f,v,[o.value,g],!0):o.value);return n.length=g,n}})},function(t,e,n){"use strict";var r=n(6),o=n(16);t.exports=function(t,e,n){e in t?r.f(t,e,o(0,n)):t[e]=n}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(){"undefined"!=typeof ga&&(window.addEventListener("error",function(t){var e=t.colno?" line:"+t.lineno+", column:"+t.colno:" line:"+t.lineno;window.ga("send","event","JavaScript Error",t.message,t.filename+e+" -> "+navigator.userAgent,0,!0)}),s.default.error=function(t){window.ga("send","event","jQuery Error",t,navigator.userAgent,0,!0)},(0,s.default)(document).ajaxError(function(t,e,n){window.ga("send","event","jQuery Ajax Error",n.url,(0,a.default)({result:t.result,status:e.status,statusText:e.statusText,crossDomain:n.crossDomain,dataType:n.dataType}),0,!0)}))}var i=n(70),a=r(i);Object.defineProperty(e,"__esModule",{value:!0}),e.default=o;var u=n(25),s=r(u)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}var o=n(0),i=r(o),a=n(1),u=r(a),s=n(19),c=r(s);Object.defineProperty(e,"__esModule",{value:!0});var l=function(){function t(){(0,i.default)(this,t)}return(0,u.default)(t,null,[{key:"isMinXS",value:function(){return 480<=c.default.getViewportSize().width}},{key:"isMinSM",value:function(){return 768<=c.default.getViewportSize().width}},{key:"isMinMD",value:function(){return 992<=c.default.getViewportSize().width}},{key:"isMinLG",value:function(){return 1200<=c.default.getViewportSize().width}},{key:"isMinXL",value:function(){return 1920<=c.default.getViewportSize().width}}]),t}();e.default=l}]);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(41)('wks');
var uid = __webpack_require__(31);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(2);
var ctx = __webpack_require__(22);
var hide = __webpack_require__(17);
var has = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(110), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(77), __esModule: true };

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(54);
var toPrimitive = __webpack_require__(36);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(68);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(123);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(127);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(68);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(131);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var createDesc = __webpack_require__(24);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(81);
var defined = __webpack_require__(34);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = TweenMax;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = log;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(30);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(78)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(53)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(10).f;
var has = __webpack_require__(18);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(80);
var enumBugKeys = __webpack_require__(42);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(35)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(57).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(42);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(33);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(41)('keys');
var uid = __webpack_require__(31);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(34);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
var global = __webpack_require__(4);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(25);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(59);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(25);
module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(30);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(29);
var wksExt = __webpack_require__(47);
var defineProperty = __webpack_require__(10).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(49);
var createDesc = __webpack_require__(24);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(36);
var has = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(54);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = THREE;

/***/ }),
/* 52 */
/***/ (function(module, exports) {



/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(25);
var $iterCreate = __webpack_require__(79);
var setToStringTag = __webpack_require__(32);
var getPrototypeOf = __webpack_require__(58);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(23)(function () {
  return Object.defineProperty(__webpack_require__(35)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(17);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(18);
var toIObject = __webpack_require__(19);
var arrayIndexOf = __webpack_require__(82)(false);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(18);
var toObject = __webpack_require__(43);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(26);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(25);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(30);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(22);
var invoke = __webpack_require__(90);
var html = __webpack_require__(57);
var cel = __webpack_require__(35);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(26)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(14);
var newPromiseCapability = __webpack_require__(46);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(6);
var core = __webpack_require__(2);
var fails = __webpack_require__(23);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(112);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(114);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(56);
var hiddenKeys = __webpack_require__(42).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Default Page.
 *
 * @extends {AbstractPage}
 * @private
 */
var DefaultPage = function (_AbstractPage) {
    (0, _inherits3.default)(DefaultPage, _AbstractPage);

    function DefaultPage() {
        (0, _classCallCheck3.default)(this, DefaultPage);
        return (0, _possibleConstructorReturn3.default)(this, (DefaultPage.__proto__ || (0, _getPrototypeOf2.default)(DefaultPage)).apply(this, arguments));
    }

    (0, _createClass3.default)(DefaultPage, [{
        key: 'init',
        value: function init() {
            (0, _get3.default)(DefaultPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(DefaultPage.prototype), 'init', this).call(this);

            // Elements
            this.$footer = (0, _jquery2.default)('#footer');
            this.$footerGradient = this.$footer.find('.footer__gradient');

            // Values
            this.navTitle = this.$cont.attr('data-nav-title');
            this.color = this.$cont.attr('data-color');

            this.setFooterColor();
        }
    }, {
        key: 'show',
        value: function show() {
            this.setFooterColor();
        }
    }, {
        key: 'getColor',
        value: function getColor() {
            return this.$cont.attr('data-color');
        }
    }, {
        key: 'getImage',
        value: function getImage() {
            return this.$cont.attr('data-image');
        }
    }, {
        key: 'setFooterColor',
        value: function setFooterColor() {
            _TweenMax2.default.to(this.$footerGradient, 1, {
                background: 'linear-gradient(rgba(0, 0, 0, 0), ' + this.color + ' 50%)'
            });
        }
    }, {
        key: 'onLazyImageProcessed',
        value: function onLazyImageProcessed(index) {}
    }, {
        key: 'onResize',
        value: function onResize() {}
    }, {
        key: 'onLazyImageSet',
        value: function onLazyImageSet(element) {}
    }, {
        key: 'onLazyImageLoad',
        value: function onLazyImageLoad(element) {}
    }]);
    return DefaultPage;
}(_startingBlocks.AbstractPage); /**
                                  * Copyright © 2017, Rezo Zero
                                  *
                                  * @file DefaultPage.js
                                  * @author Adrien Scholaert <adrien@rezo-zero.com>
                                  */

exports.default = DefaultPage;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file EventTypes.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function(strings) {
  if (typeof strings === 'string') strings = [strings]
  var exprs = [].slice.call(arguments,1)
  var parts = []
  for (var i = 0; i < strings.length-1; i++) {
    parts.push(strings[i], exprs[i] || '')
  }
  parts.push(strings[i])
  return parts.join('')
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
module.exports = __webpack_require__(149);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _startingBlocks = __webpack_require__(3);

var _loglevel = __webpack_require__(21);

var log = _interopRequireWildcard(_loglevel);

var _Splashscreen = __webpack_require__(76);

var _Splashscreen2 = _interopRequireDefault(_Splashscreen);

var _App = __webpack_require__(99);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * Copyright © 2017, Rezo Zero
 *
 * @file entry.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

(function () {
    // Config loglevel
    if (window.TEMP.debug && window.TEMP.debug === true) {
        log.setLevel(0);
    } else {
        log.setLevel(5);
    }

    // Declare polyfills
    (0, _startingBlocks.polyfills)();

    var splashscreen = new _Splashscreen2.default();
    var app = new _App2.default();

    splashscreen.$cont.on('hide', function () {
        app.iniRaf();
    });

    /// Init router, nav and sceneManager
    splashscreen.init().then(function () {
        app.init();
    });
})();

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Splashscreen.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var Splashscreen = function () {
    function Splashscreen() {
        (0, _classCallCheck3.default)(this, Splashscreen);

        this.$cont = (0, _jquery2.default)('#splashscreen');
        this.$svg = this.$cont.find('#svg-splashscreen');
        this.$bg = this.$cont.find('#splashscreen-bg');
        this.$subSvg = this.$cont.find('#sub-svg');
        this.$btn = this.$cont.find('#splashscreen-btn');
        this.bgSrc = window.TEMP.baseurl + '/assets/img/splashscreen.jpg';
        this.$body = (0, _jquery2.default)(document.body);

        this.isLock = false;
        this.setValues();

        // Binded methods
        this.onResize = this.onResize.bind(this);
        this.onBtnClick = this.onBtnClick.bind(this);
    }

    (0, _createClass3.default)(Splashscreen, [{
        key: 'init',
        value: function init() {
            var _this = this;

            return new _promise2.default(function (resolve) {
                window.addEventListener('resize', _this.onResize);
                _this.$btn.on('click touch', _this.onBtnClick);

                if (window.sessionStorage && window.sessionStorage.getItem('ntm')) {
                    _this.hide();
                    resolve();
                } else {
                    _this.$body.addClass('splashscreen-visible');
                    _this.$cont.addClass('initiate');
                    resolve();
                    // this
                    //     .loadBg()
                    //     .then(() => {
                    //         // Add initiated class
                    //         this.$cont.addClass('initiate')
                    //         resolve()
                    //     })
                }
            });
        }
    }, {
        key: 'loadBg',
        value: function loadBg() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                var img = new window.Image();

                img.addEventListener('load', function () {
                    _this2.$bg.css({
                        backgroundImage: 'url(' + _this2.bgSrc + ')'
                    });
                    resolve();
                });

                img.src = _this2.bgSrc;
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            window.removeEventListener('resize', this.onResize);
            this.$btn.off('click touch', this.onBtnClick);
            this.$cont.remove();
        }
    }, {
        key: 'onBtnClick',
        value: function onBtnClick() {
            if (this.isLock) return;
            this.isLock = true;
            this.hide();
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this3 = this;

            if (window.sessionStorage) {
                window.sessionStorage.setItem('ntm', 1);
            }

            this.$body.removeClass('splashscreen-visible');
            this.$cont.trigger('hide');

            _TweenMax2.default.to(this.$bg, 0.75, {
                autoAlpha: 0
            });

            _TweenMax2.default.to(this.$cont, 0.75, {
                autoAlpha: 0,
                delay: 0.5,
                onComplete: function onComplete() {
                    _this3.destroy();
                }
            });
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.setValues();
        }
    }, {
        key: 'setValues',
        value: function setValues() {
            // this.$svg.attr('viewBox', `0 0 3800 ${window.innerHeight}`)
            // const y = (window.innerHeight / 2) - 314
            // this.$subSvg.attr('y', `${y}`)
        }
    }]);
    return Splashscreen;
}();

exports.default = Splashscreen;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52);
__webpack_require__(28);
__webpack_require__(44);
__webpack_require__(87);
__webpack_require__(94);
__webpack_require__(95);
module.exports = __webpack_require__(2).Promise;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33);
var defined = __webpack_require__(34);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(37);
var descriptor = __webpack_require__(24);
var setToStringTag = __webpack_require__(32);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(17)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(26);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(19);
var toLength = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(83);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(33);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(85);
var step = __webpack_require__(86);
var Iterators = __webpack_require__(25);
var toIObject = __webpack_require__(19);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(53)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var global = __webpack_require__(4);
var ctx = __webpack_require__(22);
var classof = __webpack_require__(59);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(14);
var aFunction = __webpack_require__(30);
var anInstance = __webpack_require__(88);
var forOf = __webpack_require__(89);
var speciesConstructor = __webpack_require__(62);
var task = __webpack_require__(63).set;
var microtask = __webpack_require__(91)();
var newPromiseCapabilityModule = __webpack_require__(46);
var perform = __webpack_require__(64);
var promiseResolve = __webpack_require__(65);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(92)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(32)($Promise, PROMISE);
__webpack_require__(93)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(66)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(22);
var call = __webpack_require__(60);
var isArrayIter = __webpack_require__(61);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(39);
var getIterFn = __webpack_require__(45);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(63).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(26)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(17);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var core = __webpack_require__(2);
var dP = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(6);
var core = __webpack_require__(2);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(62);
var promiseResolve = __webpack_require__(65);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(46);
var perform = __webpack_require__(64);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(10).f });


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _startingBlocks = __webpack_require__(3);

var _Nav = __webpack_require__(100);

var _Nav2 = _interopRequireDefault(_Nav);

var _TransitionFactory = __webpack_require__(108);

var _TransitionFactory2 = _interopRequireDefault(_TransitionFactory);

var _ClassFactory = __webpack_require__(130);

var _ClassFactory2 = _interopRequireDefault(_ClassFactory);

var _ThreeScene = __webpack_require__(142);

var _ThreeScene2 = _interopRequireDefault(_ThreeScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function () {
    function App() {
        (0, _classCallCheck3.default)(this, App);

        /**
         * @type {ThreeScene|null}
         */
        this.sceneManager = null;
        this.router = null;
        this.nav = null;
        this.isRafInit = false;
    }

    (0, _createClass3.default)(App, [{
        key: 'init',
        value: function init() {
            this.sceneManager = new _ThreeScene2.default();

            // New Router instance
            this.router = new _startingBlocks.Router({
                useCache: true,
                lazyloadEnabled: true,
                classFactory: new _ClassFactory2.default(),
                transitionFactory: new _TransitionFactory2.default()
            });

            // New Nav instance
            this.nav = new _Nav2.default(this.router);

            // Init everything
            this.sceneManager.init();
            this.nav.init();
            this.router.init();

            if (this.sceneManager && this.isRafInit) {
                this.sceneManager.initRaf();
            }
        }
    }, {
        key: 'iniRaf',
        value: function iniRaf() {
            if (this.isRafInit) return;
            this.isRafInit = true;

            if (this.sceneManager) {
                this.sceneManager.initRaf();
            }
        }
    }]);
    return App;
}();
// import SceneManager from './scene/SceneManager'
/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file App.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

exports.default = App;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(27);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(103);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _startingBlocks = __webpack_require__(3);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = function () {
    /**
     * Nav Constructor
     */
    function Nav(router) {
        (0, _classCallCheck3.default)(this, Nav);

        this.router = router;

        // Elements
        /**
         * @type {jQuery|HTMLElement}
         */
        this.$body = (0, _jquery2.default)(document.body);
        this.$cont = (0, _jquery2.default)('#nav');
        this.$mobileBtn = (0, _jquery2.default)('#mobile-nav-btn');
        this.$navTitle = this.$cont.find('.nav__title');
        this.$links = this.$cont.find('a');

        // Values
        this.navTitle = null;
        this.firstInit = false;
        this.pageBootResolve = null;
        this.pageBootPromise = null;

        // Binded methods
        this.onBeforePageLoad = this.onBeforePageLoad.bind(this);
        this.onAfterPageBoot = this.onAfterPageBoot.bind(this);
        this.onMobileBtnClick = this.onMobileBtnClick.bind(this);
    }

    (0, _createClass3.default)(Nav, [{
        key: 'init',
        value: function init() {
            this.initEvents();
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            window.addEventListener(_startingBlocks.EventTypes.BEFORE_PAGE_LOAD, this.onBeforePageLoad);
            window.addEventListener(_startingBlocks.EventTypes.AFTER_PAGE_BOOT, this.onAfterPageBoot);
            this.$mobileBtn.on('click touch', this.onMobileBtnClick);
        }
    }, {
        key: 'onMobileBtnClick',
        value: function onMobileBtnClick() {
            this.$body.toggleClass('nav-open');
        }
    }, {
        key: 'onBeforePageLoad',
        value: function onBeforePageLoad() {
            var _this = this;

            this.pageBootPromise = new _promise2.default(function (resolve) {
                _this.pageBootResolve = resolve;
            });

            _promise2.default.all([this.hideNavTitle(), this.pageBootPromise]).then(function () {
                _this.$body.removeClass('nav-open');
                _this.setNavTitle();
                _this.showNavTitle();
            });
        }

        /**
         * @param {DefaultPage} detail
         */

    }, {
        key: 'onAfterPageBoot',
        value: function onAfterPageBoot(_ref) {
            var detail = _ref.detail;

            this.lazyloadVideos();
            this.navTitle = detail.navTitle;

            // Remove all active class
            this.$links.removeClass('active-link');

            // get latest url
            var url = this.router.history.history[this.router.history.history.length - 1].url;


            this.$links.each(function (i, link) {
                if (link.href === url) {
                    (0, _jquery2.default)(link).addClass('active-link');
                }
            });

            if (this.pageBootResolve) {
                this.pageBootResolve();
            }

            if (!this.firstInit) {
                this.firstInit = true;
                this.setNavTitle();
            }
        }
    }, {
        key: 'setNavTitle',
        value: function setNavTitle() {
            this.$navTitle.html(this.navTitle);
        }
    }, {
        key: 'hideNavTitle',
        value: function hideNavTitle() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                _TweenMax2.default.to(_this2.$navTitle, 0.5, {
                    alpha: 0,
                    onComplete: resolve
                });
            });
        }
    }, {
        key: 'showNavTitle',
        value: function showNavTitle() {
            var _this3 = this;

            return new _promise2.default(function (resolve) {
                _TweenMax2.default.to(_this3.$navTitle, 0.5, {
                    alpha: 1,
                    onComplete: resolve
                });
            });
        }
    }, {
        key: 'lazyloadVideos',
        value: function lazyloadVideos() {
            var $videos = [].concat((0, _toConsumableArray3.default)((0, _jquery2.default)('.lazyload-video')));

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)($videos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var video = _step.value;

                    var $el = (0, _jquery2.default)(video);
                    $el.attr('src', $el.attr('data-src'));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);
    return Nav;
}(); /**
      * Copyright © 2017, Rezo Zero
      *
      * This file is part of Suprême NTM.
      *
      * Suprême NTM can not be copied and/or distributed without
      * the express permission of Rezo Zero.
      *
      * @file Nav.js
      * @author Adrien Scholaert <adrien@rezo-zero.com>
      * @copyright Rezo Zero 2018
      */

exports.default = Nav;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44);
__webpack_require__(28);
module.exports = __webpack_require__(102);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var get = __webpack_require__(45);
module.exports = __webpack_require__(2).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(106);
module.exports = __webpack_require__(2).Array.from;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(22);
var $export = __webpack_require__(6);
var toObject = __webpack_require__(43);
var call = __webpack_require__(60);
var isArrayIter = __webpack_require__(61);
var toLength = __webpack_require__(39);
var createProperty = __webpack_require__(107);
var getIterFn = __webpack_require__(45);

$export($export.S + $export.F * !__webpack_require__(66)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(10);
var createDesc = __webpack_require__(24);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _FadeTransition = __webpack_require__(109);

var _FadeTransition2 = _interopRequireDefault(_FadeTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransitionFactory = function () {
    function TransitionFactory() {
        (0, _classCallCheck3.default)(this, TransitionFactory);
    }

    (0, _createClass3.default)(TransitionFactory, [{
        key: 'getTransition',
        value: function getTransition(previousState, state) {
            var transition = null;

            switch (state.transitionName) {
                case 'fade':
                    transition = new _FadeTransition2.default();
                    break;
                default:
                    transition = new _FadeTransition2.default();
                    break;
            }

            return transition;
        }
    }]);
    return TransitionFactory;
}(); /*
      * Copyright © 2017, Rezo Zero
      *
      * @file TransitionFactory.js
      * @author Adrien Scholaert <adrien@rezo-zero.com>
      */

exports.default = TransitionFactory;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fade Transition class example. Fade Out / Fade In content.
 */
var FadeTransition = function (_AbstractTransition) {
    (0, _inherits3.default)(FadeTransition, _AbstractTransition);

    function FadeTransition() {
        (0, _classCallCheck3.default)(this, FadeTransition);
        return (0, _possibleConstructorReturn3.default)(this, (FadeTransition.__proto__ || (0, _getPrototypeOf2.default)(FadeTransition)).apply(this, arguments));
    }

    (0, _createClass3.default)(FadeTransition, [{
        key: 'start',

        /**
         * Entry point of the animation
         * Automatically called on init()
         */
        value: function start() {
            // Wait new content and the end of fadeOut animation
            // this.newPageLoading is a Promise which is resolved when the new content is loaded
            _promise2.default.all([this.newPageLoading, this.fadeOut()])
            // then fadeIn the new content
            .then(this.fadeIn.bind(this));
        }

        /**
         * Fade out the old content.
         * @returns {Promise}
         */

    }, {
        key: 'fadeOut',
        value: function fadeOut() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                _this2.oldPage.$cont.animate({
                    opacity: 0
                }, 400, 'swing', resolve);
            });
        }

        /**
         * Fade in the new content
         */

    }, {
        key: 'fadeIn',
        value: function fadeIn() {
            var _this3 = this;

            // Add display: none on the old container
            this.oldPage.$cont.hide();

            // Prepare new content css properties for the fade animation
            this.newPage.$cont.css({
                visibility: 'visible',
                opacity: 0
            });

            window.scrollTo(0, 0);

            // fadeIn the new content container
            this.newPage.$cont.animate({ opacity: 1 }, 400, function () {
                // IMPORTANT: Call this method at the end
                _this3.done();
            });
        }
    }]);
    return FadeTransition;
}(_startingBlocks.AbstractTransition); /*
                                        * Copyright © 2017, Rezo Zero
                                        *
                                        * @file FadeTransition.js
                                        * @author Adrien Scholaert <adrien@rezo-zero.com>
                                        */

exports.default = FadeTransition;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111);
module.exports = __webpack_require__(2).Object.getPrototypeOf;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(43);
var $getPrototypeOf = __webpack_require__(58);

__webpack_require__(67)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(44);
module.exports = __webpack_require__(47).f('iterator');


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(115), __esModule: true };

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
__webpack_require__(52);
__webpack_require__(121);
__webpack_require__(122);
module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(55);
var META = __webpack_require__(117).KEY;
var $fails = __webpack_require__(23);
var shared = __webpack_require__(41);
var setToStringTag = __webpack_require__(32);
var uid = __webpack_require__(31);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(47);
var wksDefine = __webpack_require__(48);
var enumKeys = __webpack_require__(118);
var isArray = __webpack_require__(119);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(36);
var createDesc = __webpack_require__(24);
var _create = __webpack_require__(37);
var gOPNExt = __webpack_require__(120);
var $GOPD = __webpack_require__(50);
var $DP = __webpack_require__(10);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(70).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(49).f = $propertyIsEnumerable;
  __webpack_require__(69).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(29)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(17)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(31)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(18);
var setDesc = __webpack_require__(10).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(23)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(69);
var pIE = __webpack_require__(49);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(26);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(19);
var gOPN = __webpack_require__(70).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('asyncIterator');


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('observable');


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(124), __esModule: true };

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
module.exports = __webpack_require__(2).Object.setPrototypeOf;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(126).set });


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(7);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(22)(Function.call, __webpack_require__(50).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(128), __esModule: true };

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
var $Object = __webpack_require__(2).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(37) });


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _DefaultPage = __webpack_require__(71);

var _DefaultPage2 = _interopRequireDefault(_DefaultPage);

var _startingBlocks = __webpack_require__(3);

var _TrackBlock = __webpack_require__(134);

var _TrackBlock2 = _interopRequireDefault(_TrackBlock);

var _ConcertsBlock = __webpack_require__(136);

var _ConcertsBlock2 = _interopRequireDefault(_ConcertsBlock);

var _VideosBlock = __webpack_require__(137);

var _VideosBlock2 = _interopRequireDefault(_VideosBlock);

var _LyricsPanelBlock = __webpack_require__(138);

var _LyricsPanelBlock2 = _interopRequireDefault(_LyricsPanelBlock);

var _RushBlock = __webpack_require__(139);

var _RushBlock2 = _interopRequireDefault(_RushBlock);

var _FacebookBlock = __webpack_require__(140);

var _FacebookBlock2 = _interopRequireDefault(_FacebookBlock);

var _DiscographiePage = __webpack_require__(141);

var _DiscographiePage2 = _interopRequireDefault(_DiscographiePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Router mapper class.
 *
 * This class maps your `data-node-type` with your *ES6* classes.
 *
 * **You must define your own ClassFactory for each of your projects.**.
 */
var ClassFactory = function () {
    function ClassFactory() {
        (0, _classCallCheck3.default)(this, ClassFactory);
    }

    (0, _createClass3.default)(ClassFactory, [{
        key: 'getPageInstance',

        /**
         * Returns an `AbstractPage` child class instance
         * according to the `nodeTypeName` or an `AbstractPage` as default.
         *
         * @param  {String}  nodeType
         * @param  {Router}  router
         * @param  {HTMLElement}  container
         * @param  {String}  context
         * @param  {Boolean} isHome
         *
         * @return {AbstractPage}
         */
        value: function getPageInstance(router, container, context, nodeType) {
            switch (nodeType) {
                case 'discographie':
                    return new _DiscographiePage2.default(router, container, context, nodeType);
                default:
                    return new _DefaultPage2.default(router, container, context, nodeType);
            }
        }

        /**
         * Returns an `AbstractBlock` child class instance
         * according to the nodeTypeName or an AbstractBlock as default.
         *
         * Comment out the default case if you don’t want a default block to be instantiated
         * for each block.
         *
         * @param  {AbstractPage} page
         * @param  {jQuery}  $cont
         * @param  {String}  nodeTypeName
         * @return {AbstractBlock}
         */

    }, {
        key: 'getBlockInstance',
        value: function getBlockInstance(page, $cont, nodeTypeName) {
            switch (nodeTypeName) {
                case 'rush':
                    return new _RushBlock2.default(page, $cont, nodeTypeName);
                case 'lyric-panel':
                    return new _LyricsPanelBlock2.default(page, $cont, nodeTypeName);
                case 'track':
                    return new _TrackBlock2.default(page, $cont, nodeTypeName);
                case 'concerts':
                    return new _ConcertsBlock2.default(page, $cont, nodeTypeName);
                case 'videos':
                    return new _VideosBlock2.default(page, $cont, nodeTypeName);
                case 'facebook':
                    return new _FacebookBlock2.default(page, $cont, nodeTypeName);
                default:
                    return new _startingBlocks.AbstractBlock(page, $cont, nodeTypeName);
            }
        }
    }]);
    return ClassFactory;
}(); /**
      * Copyright © 2017, Rezo Zero
      *
      * @file ClassFactory.js
      * @author Adrien Scholaert <adrien@rezo-zero.com>
      */

exports.default = ClassFactory;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(132), __esModule: true };

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133);
var $Object = __webpack_require__(2).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(19);
var $getOwnPropertyDescriptor = __webpack_require__(50).f;

__webpack_require__(67)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _loglevel = __webpack_require__(21);

var log = _interopRequireWildcard(_loglevel);

var _Dispatcher = __webpack_require__(135);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _EventTypes = __webpack_require__(72);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) 2018. Rezo Zero
 *
 * This file is part of Supreme NTM.
 *
 * Supreme NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file TrackBlock.js
 * @author Ambroise Maupate <ambroise@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var TrackBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(TrackBlock, _AbstractBlock);

    function TrackBlock() {
        (0, _classCallCheck3.default)(this, TrackBlock);
        return (0, _possibleConstructorReturn3.default)(this, (TrackBlock.__proto__ || (0, _getPrototypeOf2.default)(TrackBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(TrackBlock, [{
        key: 'init',
        value: function init() {
            (0, _get3.default)(TrackBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(TrackBlock.prototype), 'init', this).call(this);
            log.debug('\t🎧 New track');

            // Values
            this.lyrics = this.$cont.find('.lyrics').html();

            // Binded methods
            this.onClick = this.onClick.bind(this);
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            (0, _get3.default)(TrackBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(TrackBlock.prototype), 'initEvents', this).call(this);
            this.$cont.on('click', this.onClick);
        }
    }, {
        key: 'destroyEvents',
        value: function destroyEvents() {
            (0, _get3.default)(TrackBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(TrackBlock.prototype), 'destroyEvents', this).call(this);
            this.$cont.off('click', this.onClick);
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            _Dispatcher2.default.commit(_EventTypes.TRACK_CLICK, this);
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$cont.addClass('tracks__item--active');
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.$cont.removeClass('tracks__item--active');
        }
    }]);
    return TrackBlock;
}(_startingBlocks.AbstractBlock);

exports.default = TrackBlock;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Dispatcher.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

/**
 * Event dispatcher singleton.
 */
var Dispatcher = function () {
  function Dispatcher() {
    (0, _classCallCheck3.default)(this, Dispatcher);
  }

  (0, _createClass3.default)(Dispatcher, [{
    key: "commit",
    value: function commit(eventType, detail) {
      var event = new window.CustomEvent(eventType, { detail: detail });
      window.dispatchEvent(event);
    }
  }]);
  return Dispatcher;
}();

/**
 * @ignore
 */


exports.default = new Dispatcher();

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(27);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _loglevel = __webpack_require__(21);

var log = _interopRequireWildcard(_loglevel);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConcertsBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(ConcertsBlock, _AbstractBlock);

    function ConcertsBlock() {
        (0, _classCallCheck3.default)(this, ConcertsBlock);
        return (0, _possibleConstructorReturn3.default)(this, (ConcertsBlock.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(ConcertsBlock, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'init', this).call(this);
            log.debug('\t🎤 Concerts listing');
            this.endpoint = this.$cont.attr('data-end-point');

            /**
             * @type {jQuery}
             */
            this.$body = (0, _jquery2.default)(document.body);

            if (!window.fetch) {
                throw new Error('window.fetch is not supported by your browser.');
            }

            if (this.endpoint && this.endpoint !== '') {
                this.fetchApi(this.endpoint).then(function (data) {
                    _this2.render(JSON.parse(data));
                });
            }
        }
    }, {
        key: 'fetchApi',
        value: function fetchApi(url) {
            return new _promise2.default(function (resolve, reject) {
                window.fetch(url, {
                    method: 'GET',
                    cache: 'default',
                    credentials: 'same-origin'
                }).then(function (res) {
                    if (res.status >= 200 && res.status < 300) {
                        return resolve(res.text());
                    }
                    var err = new Error(res.statusText || res.status);
                    return reject(err);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }, {
        key: 'render',
        value: function render(contents) {
            this.$body.addClass('content-loaded');

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(contents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var venue = _step.value;

                    var date = new Date(venue.datetime);
                    var monthOptions = { month: 'long', day: 'numeric' };
                    var yearOptions = { year: 'numeric' };
                    var template = '\n<div itemscope itemtype="http://schema.org/MusicEvent" class="concert d-flex" id="concert-' + venue.id + '">\n    <meta itemprop="name" content="' + venue.venue.name + '" />\n    <div class="column column--xs">\n        <time itemprop="startDate"\n              class="concert__date date" \n              datetime="' + venue.datetime + '">' + date.toLocaleDateString('fr', monthOptions) + '<br /><span class="year">' + date.toLocaleDateString('fr', yearOptions) + '</span></time>\n    </div>\n    <div class="column column--0-7 d-flex xs-inline">\n        <div itemprop="location" itemscope itemtype="http://schema.org/MusicVenue" class="concert__venue">\n            <p itemprop="name" class="concert__venue__title">' + venue.venue.name + '</p>\n            <p itemprop="address" class="concert__venue__location">' + venue.venue.city + ', ' + venue.venue.country + '</p>\n        </div>\n    </div>\n    <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" class="concert__venue__btn">\n        <a itemprop="url" target="_blank" href="' + venue.url + '" class="concert__link btn btn-default btn-hover-fill">Billet & RSVP</a>    \n    </div>\n</div>';

                    this.$cont.append(template);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'onLoad', this).call(this);
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'onResize', this).call(this);
        }
    }, {
        key: 'onPageReady',
        value: function onPageReady() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'onPageReady', this).call(this);
        }
    }, {
        key: 'destroyEvents',
        value: function destroyEvents() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'destroyEvents', this).call(this);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'destroy', this).call(this);
            this.$body.removeClass('content-loaded');
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            (0, _get3.default)(ConcertsBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConcertsBlock.prototype), 'initEvents', this).call(this);
        }
    }]);
    return ConcertsBlock;
}(_startingBlocks.AbstractBlock); /*
                                   * Copyright (c) 2018. Rezo Zero
                                   *
                                   * This file is part of Supreme NTM.
                                   *
                                   * Supreme NTM can not be copied and/or distributed without
                                   * the express permission of Rezo Zero.
                                   *
                                   * @file ConcertsBlock.js
                                   * @author Ambroise Maupate <ambroise@rezo-zero.com>
                                   * @copyright Rezo Zero 2018
                                   */

exports.default = ConcertsBlock;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(27);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _loglevel = __webpack_require__(21);

var log = _interopRequireWildcard(_loglevel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideosBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(VideosBlock, _AbstractBlock);

    function VideosBlock() {
        (0, _classCallCheck3.default)(this, VideosBlock);
        return (0, _possibleConstructorReturn3.default)(this, (VideosBlock.__proto__ || (0, _getPrototypeOf2.default)(VideosBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(VideosBlock, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            (0, _get3.default)(VideosBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(VideosBlock.prototype), 'init', this).call(this);
            log.debug('\t📺 Videos listing');

            if (!window.fetch) {
                throw new Error('window.fetch is not supported by your browser.');
            }

            this.options = {
                playlistId: window.TEMP.youtubePlaylistId,
                part: 'snippet,contentDetails',
                key: window.TEMP.googleApiKey
            };
            this.endPoint = 'https://www.googleapis.com/youtube/v3/playlistItems?' + _jquery2.default.param(this.options);
            this.fetchApi().then(function (data) {
                var jsonData = JSON.parse(data);
                _this2.render(jsonData.items);
            });
        }
    }, {
        key: 'fetchApi',
        value: function fetchApi() {
            var _this3 = this;

            return new _promise2.default(function (resolve, reject) {
                window.fetch(_this3.endPoint, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Referer': window.location.origin,
                        'credentials': 'same-origin'
                    },
                    cache: 'default'
                }).then(function (res) {
                    if (res.status >= 200 && res.status < 300) {
                        resolve(res.text());
                    }
                    var err = new Error(res.statusText || res.status);
                    reject(err);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }, {
        key: 'render',
        value: function render(contents) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(contents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var video = _step.value;

                    var date = new Date(video.snippet.publishedAt);
                    var monthOptions = { month: 'long', day: 'numeric' };
                    var yearOptions = { year: 'numeric' };
                    var template = '\n<div class="video" id="video-' + video.contentDetails.videoId + '" data-youtube-id="' + video.contentDetails.videoId + '">\n    <div class="video-details">\n        <iframe width="' + video.snippet.thumbnails.maxres.width + '"\n                height="' + video.snippet.thumbnails.maxres.height + '"\n                frameborder="0"\n                allow="autoplay; encrypted-media" \n                allowfullscreen\n                src="https://www.youtube.com/embed/' + video.contentDetails.videoId + '?rel=0&showinfo=0"></iframe>\n        <img src="' + video.snippet.thumbnails.maxres.url + '" \n             width="' + video.snippet.thumbnails.maxres.width + '" \n             height="' + video.snippet.thumbnails.maxres.height + '" \n             class="img-fluid"\n             alt="' + video.snippet.title + '">\n    </div>\n    <p class="video-title">' + video.snippet.title + '</p>\n    <time class="video-date date" \n          datetime="' + video.snippet.publishedAt + '">' + date.toLocaleDateString('fr', monthOptions) + ' <span class="year">' + date.toLocaleDateString('fr', yearOptions) + '</span></time>\n</div>';

                    this.$cont.append(template);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);
    return VideosBlock;
}(_startingBlocks.AbstractBlock); /*
                                   * Copyright (c) 2018. Rezo Zero
                                   *
                                   * This file is part of Supreme NTM.
                                   *
                                   * Supreme NTM can not be copied and/or distributed without
                                   * the express permission of Rezo Zero.
                                   *
                                   * @file VideosBlock.js
                                   * @author Ambroise Maupate <ambroise@rezo-zero.com>
                                   * @copyright Rezo Zero 2018
                                   */

exports.default = VideosBlock;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _EventTypes = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file LyricPanelBlock.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var LyricsPanelBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(LyricsPanelBlock, _AbstractBlock);

    function LyricsPanelBlock() {
        (0, _classCallCheck3.default)(this, LyricsPanelBlock);
        return (0, _possibleConstructorReturn3.default)(this, (LyricsPanelBlock.__proto__ || (0, _getPrototypeOf2.default)(LyricsPanelBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(LyricsPanelBlock, [{
        key: 'init',
        value: function init() {
            (0, _get3.default)(LyricsPanelBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(LyricsPanelBlock.prototype), 'init', this).call(this);

            /**
             * @type {jQuery}
             */
            this.$wrapper = this.$cont.find('#lyrics-panel__wrapper');

            /**
             * @type {jQuery}
             */
            this.$dynamicColumn = (0, _jquery2.default)('#dynamic-column');

            /**
             * @type {jQuery}
             */
            this.$body = (0, _jquery2.default)('body');

            /**
             * @type {jQuery}
             */
            this.$btnClose = this.$cont.find('.btn-close');

            this.state = {
                isOpen: false

                // Binded methods
            };this.onTrackClick = this.onTrackClick.bind(this);
            this.onDocumentClick = this.onDocumentClick.bind(this);
            this.hide = this.hide.bind(this);
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            (0, _get3.default)(LyricsPanelBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(LyricsPanelBlock.prototype), 'initEvents', this).call(this);
            window.addEventListener(_EventTypes.TRACK_CLICK, this.onTrackClick);
            window.addEventListener('click', this.onDocumentClick);
            this.$btnClose.on('click touch', this.hide);
        }
    }, {
        key: 'destroyEvents',
        value: function destroyEvents() {
            window.removeEventListener(_EventTypes.TRACK_CLICK, this.onTrackClick);
            window.removeEventListener('click', this.onDocumentClick);
            this.$btnClose.off('click touch', this.hide);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.hide();
            (0, _get3.default)(LyricsPanelBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(LyricsPanelBlock.prototype), 'destroy', this).call(this);
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {}
    }, {
        key: 'onResize',
        value: function onResize() {
            (0, _get3.default)(LyricsPanelBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(LyricsPanelBlock.prototype), 'onResize', this).call(this);
            this.setSize();
        }
    }, {
        key: 'onPageReady',
        value: function onPageReady() {
            this.setSize();
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(evt) {
            /**
             * @type {HTMLElement|Node|EventTarget}
             */
            var el = evt.target;

            // Go up in the nodelist until we
            // find a track item
            while (el && !this.getTrack(el)) {
                el = el.parentNode;
            }

            if (!el) {
                this.hide();
            }
        }
    }, {
        key: 'getTrack',
        value: function getTrack(el) {
            if (!el) {
                return undefined;
            }

            if ((' ' + el.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' tracks__item ') > -1) {
                return el;
            }

            if ((' ' + el.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' lyrics-panel ') > -1) {
                return el;
            }

            return undefined;
        }
    }, {
        key: 'onTrackClick',
        value: function onTrackClick(_ref) {
            var detail = _ref.detail;

            if (this.currentTrack) {
                this.currentTrack.disable();
            }

            if (detail === this.currentTrack) {
                this.hide();
                this.currentTrack = null;
                return;
            }

            this.currentTrack = detail;

            if (!this.state.isOpen) {
                this.open();
            }

            if (this.currentTrack.lyrics) {
                this.currentTrack.enable();
                this.setContent(this.currentTrack.lyrics);
            }
        }
    }, {
        key: 'setContent',
        value: function setContent(lyrics) {
            var _this2 = this;

            _TweenMax2.default.to(this.$wrapper, 0.25, {
                alpha: 0,
                onComplete: function onComplete() {
                    _this2.$wrapper.html(lyrics);

                    _TweenMax2.default.to(_this2.$wrapper, 0.25, {
                        alpha: 1
                    });
                }
            });

            this.$cont.animate({
                scrollTop: 0
            }, 250);
        }
    }, {
        key: 'open',
        value: function open() {
            this.$body.addClass('lyrics-panel--open');
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$body.removeClass('lyrics-panel--open');
        }
    }, {
        key: 'setSize',
        value: function setSize() {
            if (window.innerWidth > 992) {
                this.$cont.css({
                    width: 'calc(70% - 15px - ' + this.$dynamicColumn.outerWidth() + 'px)'
                });
            } else if (window.innerWidth > 768) {
                this.$cont.css({
                    width: 'calc(90% - 15px - ' + this.$dynamicColumn.outerWidth() + 'px)'
                });
            } else if (window.innerWidth > 576) {
                this.$cont.css({
                    width: 'calc(50vw)'
                });
            } else {
                this.$cont.css({
                    width: '100%'
                });
            }
        }
    }]);
    return LyricsPanelBlock;
}(_startingBlocks.AbstractBlock);

exports.default = LyricsPanelBlock;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file RushBlock.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var RushBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(RushBlock, _AbstractBlock);

    function RushBlock() {
        (0, _classCallCheck3.default)(this, RushBlock);
        return (0, _possibleConstructorReturn3.default)(this, (RushBlock.__proto__ || (0, _getPrototypeOf2.default)(RushBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(RushBlock, [{
        key: 'init',
        value: function init() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'init', this).call(this);

            /**
             * @type {number}
             */
            this.random = Math.floor(Math.random() * 30) + 15;

            /**
             * @type {number}
             */
            this.maxScrollTop = document.body.scrollHeight - window.innerHeight;

            // Binded methods
            this.onScroll = this.onScroll.bind(this);
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'initEvents', this).call(this);
            window.addEventListener('scroll', this.onScroll);
        }
    }, {
        key: 'destroyEvents',
        value: function destroyEvents() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'destroyEvents', this).call(this);
            window.removeEventListener('scroll', this.onScroll);
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var percent = scrollTop / this.maxScrollTop * this.random;

            _TweenMax2.default.to(this.$cont, 2.5, {
                xPercent: -percent
            });
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'onLoad', this).call(this);
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'onResize', this).call(this);
            this.maxScrollTop = document.body.scrollHeight - window.innerHeight;
        }
    }, {
        key: 'onPageReady',
        value: function onPageReady() {
            (0, _get3.default)(RushBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(RushBlock.prototype), 'onPageReady', this).call(this);
        }
    }]);
    return RushBlock;
}(_startingBlocks.AbstractBlock);

exports.default = RushBlock;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(27);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _startingBlocks = __webpack_require__(3);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _loglevel = __webpack_require__(21);

var log = _interopRequireWildcard(_loglevel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookBlock = function (_AbstractBlock) {
    (0, _inherits3.default)(FacebookBlock, _AbstractBlock);

    function FacebookBlock() {
        (0, _classCallCheck3.default)(this, FacebookBlock);
        return (0, _possibleConstructorReturn3.default)(this, (FacebookBlock.__proto__ || (0, _getPrototypeOf2.default)(FacebookBlock)).apply(this, arguments));
    }

    (0, _createClass3.default)(FacebookBlock, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            (0, _get3.default)(FacebookBlock.prototype.__proto__ || (0, _getPrototypeOf2.default)(FacebookBlock.prototype), 'init', this).call(this);
            log.debug('\t📺 Facebook listing');

            if (!window.fetch) {
                throw new Error('window.fetch is not supported by your browser.');
            }

            this.postsOptions = {
                fields: 'created_time,full_picture,message,permalink_url,name,type,shares',
                access_token: window.TEMP.facebookAccessToken
            };
            this.postsEndPoint = 'https://graph.facebook.com/' + window.TEMP.graphApiVersion + '/' + window.TEMP.facebookPageId + '/posts?' + _jquery2.default.param(this.postsOptions);

            this.pageOptions = {
                fields: 'name,picture,description,general_info,page_token',
                access_token: window.TEMP.facebookAccessToken
            };
            this.pageEndPoint = 'https://graph.facebook.com/' + window.TEMP.graphApiVersion + '/' + window.TEMP.facebookPageId + '?' + _jquery2.default.param(this.pageOptions);

            _promise2.default.all([this.fetchPageApi(), this.fetchPostApi()]).then(function (results) {
                _this2.pageInformation = JSON.parse(results[0]);
                _this2.render(JSON.parse(results[1]).data);
            });
            /* this.fetchPostApi().then(data => {
                const jsonData = JSON.parse(data)
                this.render(jsonData.data)
            }) */
        }
    }, {
        key: 'fetchPageApi',
        value: function fetchPageApi() {
            var _this3 = this;

            return new _promise2.default(function (resolve, reject) {
                window.fetch(_this3.pageEndPoint, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Referer': window.location.origin,
                        'credentials': 'same-origin'
                    },
                    cache: 'default'
                }).then(function (res) {
                    if (res.status >= 200 && res.status < 300) {
                        resolve(res.text());
                    }
                    var err = new Error(res.statusText || res.status);
                    reject(err);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }, {
        key: 'fetchPostApi',
        value: function fetchPostApi() {
            var _this4 = this;

            return new _promise2.default(function (resolve, reject) {
                window.fetch(_this4.postsEndPoint, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Referer': window.location.origin,
                        'credentials': 'same-origin'
                    },
                    cache: 'default'
                }).then(function (res) {
                    if (res.status >= 200 && res.status < 300) {
                        resolve(res.text());
                    }
                    var err = new Error(res.statusText || res.status);
                    reject(err);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }, {
        key: 'render',
        value: function render(contents) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(contents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var post = _step.value;

                    var date = window.moment(post.created_time).toDate();
                    var monthOptions = { month: 'long', day: 'numeric' };
                    var yearOptions = { year: 'numeric' };
                    var template = '\n<div class="facebook-post row" id="facebook-post-' + post.id + '" data-youtube-id="' + post.id + '">\n        <div class="column column--1-2 column--padding-top">\n            <div class="post-user">\n                <img src="' + post.full_picture + '"\n                     class="img-fluid"\n                     alt="' + post.name + '">\n            </div>\n        </div>\n        <div class="column column-1.2 column--padding-top">\n            <div class="post-details">\n                <div class="facebook-post__infos">\n                    <img src="' + this.pageInformation.picture.data.url + '"\n                         alt="' + this.pageInformation.name + '">\n                    <div class="facebook-post__infos__text">\n                        <h4>' + this.pageInformation.page_token + '</h4>\n                        <time class="post-date date"\n                              datetime="' + post.created_time + '">' + date.toLocaleDateString('fr', monthOptions) + ' <span class="year">' + date.toLocaleDateString('fr', yearOptions) + '</span></time>\n                    </div>\n                </div>\n                <p class="post-message">' + (post.message ? post.message : '') + '</p>\n                <a class="read-more" href="' + post.permalink_url + '" target="_blank" rel="nofollow">En savoir +</a>\n            </div>\n        </div>\n    </div>';

                    this.$cont.append(template);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);
    return FacebookBlock;
}(_startingBlocks.AbstractBlock); /*
                                   * Copyright (c) 2018. Rezo Zero
                                   *
                                   * This file is part of Supreme NTM.
                                   *
                                   * Supreme NTM can not be copied and/or distributed without
                                   * the express permission of Rezo Zero.
                                   *
                                   * @file FacebookBlock.js
                                   * @author Ambroise Maupate <ambroise@rezo-zero.com>
                                   * @copyright Rezo Zero 2018
                                   */

exports.default = FacebookBlock;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(27);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(16);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DefaultPage2 = __webpack_require__(71);

var _DefaultPage3 = _interopRequireDefault(_DefaultPage2);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file DiscographiePage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var DiscographiePage = function (_DefaultPage) {
    (0, _inherits3.default)(DiscographiePage, _DefaultPage);

    function DiscographiePage(router, container, context, nodeType, isHome) {
        (0, _classCallCheck3.default)(this, DiscographiePage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DiscographiePage.__proto__ || (0, _getPrototypeOf2.default)(DiscographiePage)).call(this, router, container, context, nodeType, isHome));

        _this.$body = $('body');
        _this.$albums = _this.$cont.find('.albums-item');
        _this.$filtersContainer = _this.$cont.find('#filters');
        _this.$filters = _this.$filtersContainer.find('.filters__item');

        // Bind methods
        _this.onFilterSelected = _this.onFilterSelected.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DiscographiePage, [{
        key: 'init',
        value: function init() {
            (0, _get3.default)(DiscographiePage.prototype.__proto__ || (0, _getPrototypeOf2.default)(DiscographiePage.prototype), 'init', this).call(this);
            this.$body.addClass('discographie-page');
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            (0, _get3.default)(DiscographiePage.prototype.__proto__ || (0, _getPrototypeOf2.default)(DiscographiePage.prototype), 'destroy', this).call(this);
            this.$body.removeClass('discographie-page');
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            (0, _get3.default)(DiscographiePage.prototype.__proto__ || (0, _getPrototypeOf2.default)(DiscographiePage.prototype), 'initEvents', this).call(this);

            this.$filters.on('click', this.onFilterSelected);
        }
    }, {
        key: 'destroyEvents',
        value: function destroyEvents() {
            (0, _get3.default)(DiscographiePage.prototype.__proto__ || (0, _getPrototypeOf2.default)(DiscographiePage.prototype), 'destroyEvents', this).call(this);

            this.$filters.off('click', this.onFilterSelected);
        }
    }, {
        key: 'onFilterSelected',
        value: function onFilterSelected(e) {
            var _this2 = this;

            // Unactive all filters
            this.$filters.removeClass('active');

            // Get new filter item
            var $newFilterElement = $(e.currentTarget);

            // Get new filter value
            var filterName = $newFilterElement.attr('data-filter');

            // Activate filter
            $newFilterElement.addClass('active');

            if (filterName === 'all') {
                this.resetAlbums();
            } else {
                _TweenMax2.default.to(this.$albums, 0.2, {
                    alpha: 0,
                    display: 'none',
                    onComplete: function onComplete() {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = (0, _getIterator3.default)(_this2.$albums), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var album = _step.value;

                                var $album = $(album);
                                var filters = $album.attr('data-filters').split(',');

                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(filters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var filter = _step2.value;

                                        if (filter === filterName) {
                                            _TweenMax2.default.to(album, 0.4, {
                                                alpha: 1,
                                                display: 'flex',
                                                onComplete: function onComplete() {
                                                    _this2.updateLazyload();
                                                }
                                            });

                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                });
            }
        }
    }, {
        key: 'resetAlbums',
        value: function resetAlbums() {
            _TweenMax2.default.to(this.$albums, 0.2, {
                alpha: 1,
                display: 'flex'
            });
        }
    }]);
    return DiscographiePage;
}(_DefaultPage3.default);

exports.default = DiscographiePage;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _BackgroundImage = __webpack_require__(143);

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

var _PostEffect = __webpack_require__(146);

var _PostEffect2 = _interopRequireDefault(_PostEffect);

var _startingBlocks = __webpack_require__(3);

var _three = __webpack_require__(51);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file ThreeScene.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

var ThreeScene = function () {
    function ThreeScene() {
        (0, _classCallCheck3.default)(this, ThreeScene);

        this.canvas = document.getElementById('canvas-webgl');
        this.renderer = new THREE.WebGLRenderer({
            antialias: false,
            canvas: this.canvas
        });
        this.renderBack1 = new THREE.WebGLRenderTarget(document.body.clientWidth, window.innerHeight);
        this.scene = new THREE.Scene();
        this.sceneBack = new THREE.Scene();
        this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.cameraBack = new THREE.PerspectiveCamera(45, document.body.clientWidth / window.innerHeight, 1, 10000);
        this.clock = new THREE.Clock();
        this.isRafInit = false;
        this.bgImg = new _BackgroundImage2.default();
        this.postEffect = new _PostEffect2.default(this.renderBack1.texture);

        this.onResize = this.onResize.bind(this);
        this.onBeforePageShow = this.onBeforePageShow.bind(this);
    }

    (0, _createClass3.default)(ThreeScene, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.renderer.setSize(document.body.clientWidth, window.innerHeight);
            this.renderer.setClearColor(0x555555, 1.0);
            this.cameraBack.position.set(1000, 1000, 1000);
            this.cameraBack.lookAt(new THREE.Vector3());

            this.bgImg.init(function () {
                _this.sceneBack.add(_this.bgImg.obj);
                _this.scene.add(_this.postEffect.obj);
            });

            this.initEvents();
            this.onResize();
        }
    }, {
        key: 'initRaf',
        value: function initRaf() {
            if (this.isRafInit) return;
            this.isRafInit = true;
            this.renderLoop();
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.canvas.width = document.body.clientWidth;
            this.canvas.height = window.innerHeight;
            this.cameraBack.aspect = document.body.clientWidth / window.innerHeight;
            this.cameraBack.updateProjectionMatrix();
            this.bgImg.resize();
            this.postEffect.resize();
            this.renderBack1.setSize(document.body.clientWidth, window.innerHeight);
            this.renderer.setSize(document.body.clientWidth, window.innerHeight);
        }
    }, {
        key: 'render',
        value: function render() {
            var time = this.clock.getDelta();
            this.renderer.render(this.sceneBack, this.cameraBack, this.renderBack1);
            this.postEffect.render(time);
            this.renderer.render(this.scene, this.camera);
        }
    }, {
        key: 'renderLoop',
        value: function renderLoop() {
            this.render();
            window.requestAnimationFrame(this.renderLoop.bind(this));
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            window.addEventListener('resize', this.onResize);
            window.addEventListener(_startingBlocks.EventTypes.BEFORE_PAGE_SHOW, this.onBeforePageShow);
        }

        /**
         * @param {CustomEvent} e
         */

    }, {
        key: 'onBeforePageShow',
        value: function onBeforePageShow(e) {
            var _this2 = this;

            /**
             * @type {DefaultPage}
             */
            var page = e.detail;

            _promise2.default.all([this.postEffect.glitchIt(), this.bgImg.loadImage(page.getImage())]).then(function () {
                _this2.bgImg.switchImage();
                _this2.postEffect.unGlitchIt();
            });
        }
    }]);
    return ThreeScene;
}();

exports.default = ThreeScene;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _glslify = __webpack_require__(73);

var _glslify2 = _interopRequireDefault(_glslify);

var _backgroundImageF = __webpack_require__(144);

var _backgroundImageF2 = _interopRequireDefault(_backgroundImageF);

var _backgroundImageV = __webpack_require__(145);

var _backgroundImageV2 = _interopRequireDefault(_backgroundImageV);

var _three = __webpack_require__(51);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file BackgroundImage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */
var BackgroundImage = function () {
    function BackgroundImage() {
        (0, _classCallCheck3.default)(this, BackgroundImage);

        this.uniforms = {
            resolution: {
                type: 'v2',
                value: new THREE.Vector2(document.body.clientWidth, window.innerHeight)
            },
            imageResolution: {
                type: 'v2',
                value: new THREE.Vector2(2048, 1356)
            },
            texture: {
                type: 't',
                value: null
            }
        };

        this.loader = new THREE.TextureLoader();
        this.isInit = false;
        this.imageUrl = null;
        this.tex = null;
        this.obj = null;
    }

    (0, _createClass3.default)(BackgroundImage, [{
        key: 'init',
        value: function init(callback) {
            if (this.isInit) return;
            this.isInit = true;

            this.uniforms.texture.value = null;
            this.obj = this.createObj();

            callback();
        }
    }, {
        key: 'loadImage',
        value: function loadImage(imageUrl) {
            var _this = this;

            return new _promise2.default(function (resolve) {
                _this.imageUrl = imageUrl;
                _this.loader.load(_this.imageUrl, function (tex) {
                    _this.tex = tex;
                    resolve();
                });
            });
        }
    }, {
        key: 'switchImage',
        value: function switchImage() {
            this.uniforms.texture.value = this.tex;
        }
    }, {
        key: 'createObj',
        value: function createObj() {
            return new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), new THREE.RawShaderMaterial({
                uniforms: this.uniforms,
                vertexShader: (0, _glslify2.default)(_backgroundImageV2.default),
                fragmentShader: (0, _glslify2.default)(_backgroundImageF2.default)
            }));
        }
    }, {
        key: 'resize',
        value: function resize() {
            this.uniforms.resolution.value.set(document.body.clientWidth, window.innerHeight);
        }
    }]);
    return BackgroundImage;
}();

exports.default = BackgroundImage;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform vec2 resolution;\nuniform vec2 imageResolution;\nuniform sampler2D texture;\n\nvarying vec2 vUv;\n\nvoid main(void) {\n  vec2 ratio = vec2(\n      min((resolution.x / resolution.y) / (imageResolution.x / imageResolution.y), 1.0),\n      min((resolution.y / resolution.x) / (imageResolution.y / imageResolution.x), 1.0)\n    );\n\n  vec2 uv = vec2(\n      vUv.x * ratio.x + (1.0 - ratio.x) * 0.5,\n      vUv.y * ratio.y + (1.0 - ratio.y) * 0.5\n    );\n  gl_FragColor = texture2D(texture, uv);\n}\n"

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "#define GLSLIFY 1\nattribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vUv;\n\nvoid main(void) {\n  vUv = uv;\n  gl_Position = vec4(position, 1.0);\n}\n"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(9);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _glslify = __webpack_require__(73);

var _glslify2 = _interopRequireDefault(_glslify);

var _TweenMax = __webpack_require__(20);

var _TweenMax2 = _interopRequireDefault(_TweenMax);

var _postEffectF = __webpack_require__(147);

var _postEffectF2 = _interopRequireDefault(_postEffectF);

var _postEffectV = __webpack_require__(148);

var _postEffectV2 = _interopRequireDefault(_postEffectV);

var _three = __webpack_require__(51);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostEffect = function () {
    function PostEffect(texture) {
        (0, _classCallCheck3.default)(this, PostEffect);

        this.uniforms = {
            time: {
                type: 'f',
                value: 0
            },
            resolution: {
                type: 'v2',
                value: new THREE.Vector2(document.body.clientWidth, window.innerHeight)
            },
            texture: {
                type: 't',
                value: texture
            },
            strength: {
                type: 'f',
                value: 0
            }
        };
        this.obj = this.createObj();

        this.glitchIt();
    }

    (0, _createClass3.default)(PostEffect, [{
        key: 'glitchIt',
        value: function glitchIt() {
            var _this = this;

            return new _promise2.default(function (resolve) {
                _TweenMax2.default.to(_this.uniforms.strength, 1, {
                    value: 1,
                    onComplete: resolve
                });
            });
        }
    }, {
        key: 'unGlitchIt',
        value: function unGlitchIt() {
            _TweenMax2.default.to(this.uniforms.strength, 1, {
                value: 0
            });
        }
    }, {
        key: 'createObj',
        value: function createObj() {
            return new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), new THREE.RawShaderMaterial({
                uniforms: this.uniforms,
                vertexShader: (0, _glslify2.default)(_postEffectV2.default),
                fragmentShader: (0, _glslify2.default)(_postEffectF2.default)
            }));
        }
    }, {
        key: 'render',
        value: function render(time) {
            this.uniforms.time.value += time;
        }
    }, {
        key: 'resize',
        value: function resize() {
            this.uniforms.resolution.value.set(document.body.clientWidth, window.innerHeight);
        }
    }]);
    return PostEffect;
}(); /*
      * Copyright © 2017, Rezo Zero
      *
      * This file is part of Suprême NTM.
      *
      * Suprême NTM can not be copied and/or distributed without
      * the express permission of Rezo Zero.
      *
      * @file PostEffect.js
      * @author Adrien Scholaert <adrien@rezo-zero.com>
      * @copyright Rezo Zero 2018
      */

exports.default = PostEffect;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform float time;\nuniform float strength;\nuniform vec2 resolution;\nuniform sampler2D texture;\n\nvarying vec2 vUv;\n\nfloat random_1_0(vec2 c){\n  return fract(sin(dot(c.xy ,vec2(12.9898,78.233))) * 43758.5453);\n}\n\n\n//\n// Description : Array and textureless GLSL 2D/3D/4D simplex\n//               noise functions.\n//      Author : Ian McEwan, Ashima Arts.\n//  Maintainer : ijm\n//     Lastmod : 20110822 (ijm)\n//     License : Copyright (C) 2011 Ashima Arts. All rights reserved.\n//               Distributed under the MIT License. See LICENSE file.\n//               https://github.com/ashima/webgl-noise\n//\n\nvec3 mod289_2_1(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289_2_1(vec4 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute_2_2(vec4 x) {\n     return mod289_2_1(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt_2_3(vec4 r)\n{\n  return 1.79284291400159 - 0.85373472095314 * r;\n}\n\nfloat snoise_2_4(vec3 v)\n  {\n  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;\n  const vec4  D_2_5 = vec4(0.0, 0.5, 1.0, 2.0);\n\n// First corner\n  vec3 i  = floor(v + dot(v, C.yyy) );\n  vec3 x0 =   v - i + dot(i, C.xxx) ;\n\n// Other corners\n  vec3 g_2_6 = step(x0.yzx, x0.xyz);\n  vec3 l = 1.0 - g_2_6;\n  vec3 i1 = min( g_2_6.xyz, l.zxy );\n  vec3 i2 = max( g_2_6.xyz, l.zxy );\n\n  //   x0 = x0 - 0.0 + 0.0 * C.xxx;\n  //   x1 = x0 - i1  + 1.0 * C.xxx;\n  //   x2 = x0 - i2  + 2.0 * C.xxx;\n  //   x3 = x0 - 1.0 + 3.0 * C.xxx;\n  vec3 x1 = x0 - i1 + C.xxx;\n  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y\n  vec3 x3 = x0 - D_2_5.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y\n\n// Permutations\n  i = mod289_2_1(i);\n  vec4 p = permute_2_2( permute_2_2( permute_2_2(\n             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))\n           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))\n           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));\n\n// Gradients: 7x7 points over a square, mapped onto an octahedron.\n// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)\n  float n_ = 0.142857142857; // 1.0/7.0\n  vec3  ns = n_ * D_2_5.wyz - D_2_5.xzx;\n\n  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)\n\n  vec4 x_ = floor(j * ns.z);\n  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)\n\n  vec4 x = x_ *ns.x + ns.yyyy;\n  vec4 y = y_ *ns.x + ns.yyyy;\n  vec4 h = 1.0 - abs(x) - abs(y);\n\n  vec4 b0 = vec4( x.xy, y.xy );\n  vec4 b1 = vec4( x.zw, y.zw );\n\n  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;\n  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;\n  vec4 s0 = floor(b0)*2.0 + 1.0;\n  vec4 s1 = floor(b1)*2.0 + 1.0;\n  vec4 sh = -step(h, vec4(0.0));\n\n  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;\n  vec4 a1_2_7 = b1.xzyw + s1.xzyw*sh.zzww ;\n\n  vec3 p0_2_8 = vec3(a0.xy,h.x);\n  vec3 p1 = vec3(a0.zw,h.y);\n  vec3 p2 = vec3(a1_2_7.xy,h.z);\n  vec3 p3 = vec3(a1_2_7.zw,h.w);\n\n//Normalise gradients\n  vec4 norm = taylorInvSqrt_2_3(vec4(dot(p0_2_8,p0_2_8), dot(p1,p1), dot(p2, p2), dot(p3,p3)));\n  p0_2_8 *= norm.x;\n  p1 *= norm.y;\n  p2 *= norm.z;\n  p3 *= norm.w;\n\n// Mix final noise value\n  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);\n  m = m * m;\n  return 42.0 * dot( m*m, vec4( dot(p0_2_8,x0), dot(p1,x1),\n                                dot(p2,x2), dot(p3,x3) ) );\n  }\n\n\n\n\n// const float interval = 3.0;\n\nvoid main(void){\n  //float strength = smoothstep(interval * 0.5, interval, interval - mod(time, interval));\n\n  vec2 shake = vec2(strength * 8.0 + 0.5) * vec2(\n    random_1_0(vec2(time)) * 2.0 - 1.0,\n    random_1_0(vec2(time * 2.0)) * 2.0 - 1.0\n  ) / resolution;\n\n  float y = vUv.y * resolution.y;\n  float rgbWave = (\n      snoise_2_4(vec3(0.0, y * 0.01, time * 400.0)) * (2.0 + strength * 32.0)\n      * snoise_2_4(vec3(0.0, y * 0.02, time * 200.0)) * (1.0 + strength * 4.0)\n      + step(0.9995, sin(y * 0.005 + time * 1.6)) * 12.0\n      + step(0.9999, sin(y * 0.005 + time * 2.0)) * -18.0\n    ) / resolution.x;\n  float rgbDiff = (6.0 + sin(time * 500.0 + vUv.y * 40.0) * (20.0 * strength + 1.0)) / resolution.x;\n  float rgbUvX = vUv.x + rgbWave;\n  float r = texture2D(texture, vec2(rgbUvX + rgbDiff, vUv.y) + shake).r;\n  float g = texture2D(texture, vec2(rgbUvX, vUv.y) + shake).g;\n  float b = texture2D(texture, vec2(rgbUvX - rgbDiff, vUv.y) + shake).b;\n\n  //float whiteNoise = (random(vUv + mod(time, 10.0)) * 2.0 - 1.0) * (0.15 + strength * 0.15);\n  float whiteNoise = (random_1_0(vUv + mod(time, 10.0)) * 1.3 - 0.20) * (0.15 + strength * 0.15);\n\n  float bnTime = floor(time * 20.0) * 200.0;\n  float noiseX = step((snoise_2_4(vec3(0.0, vUv.x * 3.0, bnTime)) + 1.0) / 2.0, 0.12 + strength * 0.3);\n  float noiseY = step((snoise_2_4(vec3(0.0, vUv.y * 3.0, bnTime)) + 1.0) / 2.0, 0.12 + strength * 0.3);\n  float bnMask = noiseX * noiseY;\n  float bnUvX = vUv.x + sin(bnTime) * 0.2 + rgbWave;\n  float bnR = texture2D(texture, vec2(bnUvX + rgbDiff, vUv.y)).r * bnMask;\n  float bnG = texture2D(texture, vec2(bnUvX, vUv.y)).g * bnMask;\n  float bnB = texture2D(texture, vec2(bnUvX - rgbDiff, vUv.y)).b * bnMask;\n  vec4 blockNoise = vec4(bnR, bnG, bnB, 1.0);\n\n  float bnTime2 = floor(time * 25.0) * 300.0;\n  float noiseX2 = step((snoise_2_4(vec3(0.0, vUv.x * 2.0, bnTime2)) + 1.0) / 2.0, 0.12 + strength * 0.5);\n  float noiseY2 = step((snoise_2_4(vec3(0.0, vUv.y * 8.0, bnTime2)) + 1.0) / 2.0, 0.12 + strength * 0.3);\n  float bnMask2 = noiseX2 * noiseY2;\n  float bnR2 = texture2D(texture, vec2(bnUvX + rgbDiff, vUv.y)).r * bnMask2;\n  float bnG2 = texture2D(texture, vec2(bnUvX, vUv.y)).g * bnMask2;\n  float bnB2 = texture2D(texture, vec2(bnUvX - rgbDiff, vUv.y)).b * bnMask2;\n  vec4 blockNoise2 = vec4(bnR2, bnG2, bnB2, 1.0);\n\n  float waveNoise = (sin(vUv.y * 1200.0) + 1.0) / 4.0 * (0.15 + strength * 0.2);\n\n  gl_FragColor = vec4(r, g, b, 1.0) * (1.0 - bnMask - bnMask2) + (whiteNoise + blockNoise + blockNoise2 - waveNoise);\n}\n"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "#define GLSLIFY 1\nattribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vUv;\n\nvoid main() {\n  vUv = uv;\n  gl_Position = vec4(position, 1.0);\n}\n"

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/bundle.js